webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(237)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(310),
  /* scopeId */
  "data-v-f5c37092",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var api = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: 'https://rocky-savannah-28401.herokuapp.com/api/v1',
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(function (config) {
  var token = localStorage.getItem('sts_token');
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

var saveRefreshedToken = function saveRefreshedToken(response) {
  var newToken = response.headers['authorization'];
  if (newToken) {
    var token = newToken.split(' ')[1];
    if (token) {
      localStorage.setItem('sts_token', token);
    }
  }
};

var redirectToLogin = function redirectToLogin() {
  if (window.location.pathname.indexOf('/login') === 0) return;
  var match = window.location.search.match(/[?&]package=([^&]*)/);
  var query = match ? '?package=' + match[1] : '';
  window.location.replace('/login' + query);
};

api.interceptors.response.use(function (response) {
  saveRefreshedToken(response);
  return response;
}, function (error) {
  if (error.response) {
    saveRefreshedToken(error.response);
    if (error.response.status === 401) {
      localStorage.removeItem('sts_token');
      redirectToLogin();
    }
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(13);




var AuthRepository = function () {
  function AuthRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AuthRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AuthRepository, [{
    key: 'register',
    value: function register(data) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/users', data).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'login',
    value: function login(email, pw) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/users/signin', {
        email: email,
        password: pw
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get',
    value: function get(token) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/users?token=' + token).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save',
    value: function save(user) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].put('/users/' + user.id, user).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'changePassword',
    value: function changePassword(obj) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].put('/changePassword/' + obj.id, obj).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'resetPassword',
    value: function resetPassword(email) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/users/resetpassword', { email: email }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return AuthRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = (new AuthRepository());

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(13);




var ProductRepository = function () {
  function ProductRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ProductRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ProductRepository, [{
    key: 'getAll',
    value: function getAll() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/products').then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'getBySlug',
    value: function getBySlug(slug) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/products/' + slug).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'createOrder',
    value: function createOrder(data) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/product-orders/create', data).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'captureOrder',
    value: function captureOrder(orderId) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/product-orders/' + orderId + '/capture').then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'getUserOrders',
    value: function getUserOrders() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/product-orders/user').then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'getOrder',
    value: function getOrder(orderId) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/product-orders/' + orderId).then(function (response) {
        return response.data;
      });
    }
  }]);

  return ProductRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = (new ProductRepository());

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PACKAGES; });
var PACKAGES = {
  ALL_ONE: 'ALL1',
  ALL_TWO: 'ALL2',
  ALL_MONTH: 'ALLMO',
  ALL_YEAR: 'ALLYR',
  NHL_FULL: 'NHLFULL',
  NFL_FULL: 'NFLFULL',
  NCAAF_FULL: 'NCAAFFULL',
  NBA_FULL: 'NBAFULL',
  NCAAB_FULL: 'NCAABFULL',
  MLB_FULL: 'MLBFULL'
};

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(119);








__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: false,
  state: {
    currentUser: {},
    currentPackage: {},
    isAuthenticated: false,
    sports: [],
    packages: [],
    categories: [],
    products: [],
    currentProduct: null,
    cart: []
  },
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_PACKAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_CURRENT_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADD_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REMOVE_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_CART_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CLEAR_CART; });
var SET_USER = 'setUser';
var SET_PACKAGES = 'setPackages';
var SET_PACKAGE = 'setCurrentPackage';

var SET_PRODUCTS = 'setProducts';
var SET_CURRENT_PRODUCT = 'setCurrentProduct';

var SET_CART = 'setCart';
var ADD_TO_CART = 'addToCart';
var REMOVE_FROM_CART = 'removeFromCart';
var UPDATE_CART_ITEM = 'updateCartItem';
var CLEAR_CART = 'clearCart';

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(231)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(303),
  /* scopeId */
  "data-v-910964e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Shell__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Shell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Shell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Testimonials__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Testimonials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Testimonials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Blog__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Blog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Blog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Contact__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Help__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Buy__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Buy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Buy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Picks__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Picks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Picks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Register__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Login__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_MyAccount__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_MyAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_MyAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_ChangePassword__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_ChangePassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_ChangePassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_ForgotPassword__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_ForgotPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_ForgotPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Admin__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_ManageRecord__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_ManageRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_ManageRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Purchase__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Purchase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_Purchase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Size__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_Size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Shop__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Shop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_Shop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_ProductDetail__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_ProductDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_ProductDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Cart__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Checkout__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_Checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_Checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_OrderConfirmation__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_OrderConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_OrderConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_MyOrders__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_MyOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_MyOrders__);



























var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_Shell___default.a,
  children: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home___default.a,
    name: 'home',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/testimonials',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Testimonials___default.a,
    name: 'testimonials',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/blog',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Blog___default.a,
    name: 'blog',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/contact',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Contact___default.a,
    name: 'contact',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/purchase',
    component: __WEBPACK_IMPORTED_MODULE_16__pages_Purchase___default.a,
    name: 'purchase'
  }, {
    path: '/help',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Help___default.a,
    name: 'help',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/buy',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Buy___default.a,
    name: 'buy',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/picks',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Picks___default.a,
    name: 'picks',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/myaccount',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_MyAccount___default.a,
    name: 'myaccount',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/changepassword',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_ChangePassword___default.a,
    name: 'changepassword',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/tools/size',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_Size___default.a,
    name: 'size',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/shop',
    component: __WEBPACK_IMPORTED_MODULE_18__pages_Shop___default.a,
    name: 'shop'
  }, {
    path: '/shop/:slug',
    component: __WEBPACK_IMPORTED_MODULE_19__pages_ProductDetail___default.a,
    name: 'product-detail'
  }, {
    path: '/cart',
    component: __WEBPACK_IMPORTED_MODULE_20__pages_Cart___default.a,
    name: 'cart'
  }, {
    path: '/checkout',
    component: __WEBPACK_IMPORTED_MODULE_21__pages_Checkout___default.a,
    name: 'checkout',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/order-confirmation/:id',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_OrderConfirmation___default.a,
    name: 'order-confirmation',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/orders',
    component: __WEBPACK_IMPORTED_MODULE_23__pages_MyOrders___default.a,
    name: 'orders',
    beforeEnter: function beforeEnter(to, from, next) {
      return check(next);
    }
  }, {
    path: '/admin',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_Admin___default.a,
    name: 'admin',
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, {
    path: '/managerecord',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_ManageRecord___default.a,
    name: 'managerecord',
    beforeEnter: function beforeEnter(to, from, next) {
      return checkAdmin(next);
    }
  }, { path: '/register', component: __WEBPACK_IMPORTED_MODULE_9__pages_Register___default.a, name: 'register' }, {
    path: '/forgotpassword',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_ForgotPassword___default.a,
    name: 'forgotpassword'
  }, {
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_Login___default.a,
    name: 'login',
    beforeEnter: function beforeEnter(to, from, next) {
      return checkSignIn(next);
    }
  }]
}];

function checkAdmin(next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.currentUser || !__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.currentUser.admin) {
    return next('/');
  }
  return next();
}

function check(next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.currentUser) return next('/login');
  return next();
}

function checkSignIn(next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.currentUser) return next('/');
  return next();
}

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(236)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(308),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var ContactRepository = function () {
  function ContactRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ContactRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ContactRepository, [{
    key: 'send',
    value: function send(data) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/contact', data).then(function (response) {
        return response.data;
      });
    }
  }]);

  return ContactRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = (new ContactRepository());

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var PackageRepository = function () {
  function PackageRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PackageRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PackageRepository, [{
    key: 'get',
    value: function get() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/packages').then(function (response) {
        return response.data;
      });
    }
  }]);

  return PackageRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = (new PackageRepository());

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(13);




var PickRepository = function () {
  function PickRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PickRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PickRepository, [{
    key: 'getFreePicks',
    value: function getFreePicks() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/picks').then(function (response) {
        return response.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, {
    key: 'getPremium',
    value: function getPremium() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/premium').then(function (response) {
        return response.data;
      });
    }
  }]);

  return PickRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = (new PickRepository());

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var PostRepository = function () {
  function PostRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PostRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PostRepository, [{
    key: 'get',
    value: function get(page, category, month, year) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://rocky-savannah-28401.herokuapp.com/api/v1' + '/posts', {
        params: {
          page: page,
          category: category,
          month: month,
          year: year
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return PostRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = (new PostRepository());

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(13);




var PurchaseRepository = function () {
  function PurchaseRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PurchaseRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PurchaseRepository, [{
    key: 'create',
    value: function create(data) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/orders', data);
    }
  }, {
    key: 'capture',
    value: function capture(data) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/orders/' + data.orderID + '/capture');
    }
  }]);

  return PurchaseRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = (new PurchaseRepository());

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(13);




var PushRepository = function () {
  function PushRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PushRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PushRepository, [{
    key: 'subscribe',
    value: function subscribe(subscription) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/push-subscriptions', subscription).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe(endpoint) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].delete('/push-subscriptions', { data: { endpoint: endpoint } }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'getSubscriptions',
    value: function getSubscriptions() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/push-subscriptions').then(function (response) {
        return response.data;
      });
    }
  }]);

  return PushRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = (new PushRepository());

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(13);




var RecordRepository = function () {
  function RecordRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RecordRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(RecordRepository, [{
    key: 'get',
    value: function get(page) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/records', {
        params: {
          page: page
        }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'getForResultsPage',
    value: function getForResultsPage() {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].get('/records').then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save',
    value: function save(record) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].put('/records/' + record.record_id, record).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'remove',
    value: function remove(record) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].delete('/records/' + record.record_id);
    }
  }]);

  return RecordRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = (new RecordRepository());

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var TestimonialRepository = function () {
  function TestimonialRepository() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TestimonialRepository);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TestimonialRepository, [{
    key: 'getTestimonials',
    value: function getTestimonials(count) {
      var url = count ? 'https://rocky-savannah-28401.herokuapp.com/api/v1' + '/testimonials?count=' + count : 'https://rocky-savannah-28401.herokuapp.com/api/v1' + '/testimonials';
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
        if (count) return response.data[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data)[0]];else return response.data;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }]);

  return TestimonialRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = (new TestimonialRepository());

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(13);




var ToolRepository = function () {
  function ToolRepository() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ToolRepository);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ToolRepository, [{
    key: 'size',
    value: function size(data) {
      return __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */].post('/tools/size', data).then(function (response) {
        return response.data;
      });
    }
  }]);

  return ToolRepository;
}();

/* harmony default export */ __webpack_exports__["a"] = (new ToolRepository());

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_meta__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js_plugins_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_store__ = __webpack_require__(54);
















__WEBPACK_IMPORTED_MODULE_2_vue___default.a.config.productionTip = false;

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_11__routes__["a" /* routes */],
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

__WEBPACK_IMPORTED_MODULE_10_axios___default.a.interceptors.response.use(function (response) {
  if (response.headers['x-token'] && response.config.url.indexOf('api/v1') > 0) {
    localStorage.setItem('sts_token', response.headers['x-token']);
  }
  return response;
}, function (error) {
  if (error.response.status === 401 || error.response.data.error === 'token_expired') {
    localStorage.removeItem('sts_token');
    router.go('/');
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_8_vee_validate___default.a.Validator.extend('american_odds', {
  getMessage: function getMessage(field) {
    return field + ' must be a valid American odds format (e.g., +150 or -200)';
  },
  validate: function validate(value) {
    return (/^[-+]?([1-9]\d{0,2}|1000)$/.test(value)
    );
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vee_validate___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_meta___default.a, {
  keyName: 'metaInfo'
});
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_vue_analytics___default.a, {
  id: 'UA-36581750-1',
  router: router
});
__WEBPACK_IMPORTED_MODULE_6_raven_js___default.a.config('https://d2462cd8e8b2484ebe278fddc1c4b5b7@sentry.io/185848', {
  release: '1.0.0',
  ignoreErrors: [/Validation Failed/, /Detected close during init/, 'adsbygoogle', 'xcomponent', 'No response from window', /postrobot_method/, 'show_ads', 'pagead', /ResizeObserver loop/, 'Can not render button in IE intranet mode', 'No window to focus'],
  ignoreUrls: [/localhost/, /googlesyndication\.com/]
}).addPlugin(__WEBPACK_IMPORTED_MODULE_7_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_2_vue___default.a).install();

new __WEBPACK_IMPORTED_MODULE_2_vue___default.a(__WEBPACK_IMPORTED_MODULE_2_vue___default.a.util.extend({ router: router, store: __WEBPACK_IMPORTED_MODULE_12__store_store__["a" /* store */] }, __WEBPACK_IMPORTED_MODULE_3__App___default.a)).$mount('#app');

if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/sw.js');
  });
}

window.deferredInstallPrompt = null;
window.addEventListener('beforeinstallprompt', function (e) {
  e.preventDefault();
  window.deferredInstallPrompt = e;
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_auth_repository__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_package_repository__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_product_repository__ = __webpack_require__(23);







/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(context, data) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__data_auth_repository__["a" /* default */].login(data.email, data.password).then(function (response) {
        localStorage.setItem('sts_token', response.token);
        context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_USER */], response.user);
        resolve(response.user);
      }).catch(function (e) {
        reject(e);
      });
    });
  },
  logout: function logout(context, data) {
    localStorage.removeItem('sts_token');
    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_USER */]);
  },
  getStoredUser: function getStoredUser(context, data) {
    var token = localStorage.getItem('sts_token');
    if (!token) {
      return context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_USER */], null);
    } else {
      return __WEBPACK_IMPORTED_MODULE_3__data_auth_repository__["a" /* default */].get(token).then(function (user) {
        return context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_USER */], user);
      }).catch(function () {
        localStorage.removeItem('sts_token');
        return context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_USER */], null);
      });
    }
  },
  getPackages: function getPackages(context, data) {
    __WEBPACK_IMPORTED_MODULE_4__data_package_repository__["a" /* default */].get().then(function (ps) {
      context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SET_PACKAGES */], ps);
    });
  },
  setCurrentPackage: function setCurrentPackage(context, data) {
    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_PACKAGE */], data);
  },
  getProducts: function getProducts(context) {
    return __WEBPACK_IMPORTED_MODULE_5__data_product_repository__["a" /* default */].getAll().then(function (products) {
      context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_PRODUCTS */], products);
      return products;
    });
  },
  setCurrentProduct: function setCurrentProduct(context, product) {
    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_CURRENT_PRODUCT */], product);
  },
  loadCart: function loadCart(context) {
    var cart = localStorage.getItem('sts_cart');
    if (cart) {
      context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* SET_CART */], JSON.parse(cart));
    }
  },
  addToCart: function addToCart(context, item) {
    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* ADD_TO_CART */], item);
    localStorage.setItem('sts_cart', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(context.state.cart));
  },
  removeFromCart: function removeFromCart(context, variantId) {
    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* REMOVE_FROM_CART */], variantId);
    localStorage.setItem('sts_cart', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(context.state.cart));
  },
  updateCartItem: function updateCartItem(context, payload) {
    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* UPDATE_CART_ITEM */], payload);
    localStorage.setItem('sts_cart', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(context.state.cart));
  },
  clearCart: function clearCart(context) {
    context.commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* CLEAR_CART */]);
    localStorage.removeItem('sts_cart');
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

/* harmony default export */ __webpack_exports__["a"] = ({
  package: function _package(state, getters) {
    return function (id) {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.packages, ['id', id]);
    };
  },
  cartItemCount: function cartItemCount(state) {
    return state.cart.reduce(function (total, item) {
      return total + item.quantity;
    }, 0);
  },
  cartTotal: function cartTotal(state) {
    return state.cart.reduce(function (total, item) {
      return total + item.price * item.quantity;
    }, 0);
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


var _SET_USER$SET_PACKAGE;




/* harmony default export */ __webpack_exports__["a"] = (_SET_USER$SET_PACKAGE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_PACKAGE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_USER */], function (state, user) {
  state.currentUser = user;
  state.isAuthenticated = !__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isUndefined(state.currentUser);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_PACKAGE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_PACKAGES */], function (state, packages) {
  state.packages = packages;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_PACKAGE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_PACKAGE */], function (state, pkg) {
  state.currentPackage = pkg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_PACKAGE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SET_PRODUCTS */], function (state, products) {
  state.products = products;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_PACKAGE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* SET_CURRENT_PRODUCT */], function (state, product) {
  state.currentProduct = product;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_PACKAGE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* SET_CART */], function (state, cart) {
  state.cart = cart;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_PACKAGE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* ADD_TO_CART */], function (state, item) {
  var existing = state.cart.find(function (i) {
    return i.variantId === item.variantId;
  });
  if (existing) {
    existing.quantity += item.quantity;
  } else {
    state.cart.push(item);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_PACKAGE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* REMOVE_FROM_CART */], function (state, variantId) {
  state.cart = state.cart.filter(function (i) {
    return i.variantId !== variantId;
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_PACKAGE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* UPDATE_CART_ITEM */], function (state, _ref) {
  var variantId = _ref.variantId,
      quantity = _ref.quantity;

  var item = state.cart.find(function (i) {
    return i.variantId === variantId;
  });
  if (item) {
    item.quantity = quantity;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_USER$SET_PACKAGE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* CLEAR_CART */], function (state) {
  state.cart = [];
}), _SET_USER$SET_PACKAGE);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CartIcon',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['cartItemCount'])),
  methods: {
    goToCart: function goToCart() {
      if (this.cartItemCount === 0) {
        this.$router.push('/shop');
      } else {
        this.$router.push('/cart');
      }
    }
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IOSInstallGuide'
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    openMenu: function openMenu() {
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_push_repository__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IOSInstallGuide__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IOSInstallGuide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__IOSInstallGuide__);







function getVapidPublicKey() {
  return "string" !== 'undefined' && "BIUz7IP78unMBmcGsfYR9dSXRe1MRgW-WAgmvMY810TAtKLiObT5vCKFcEuyO6KVNV0VSEsN8zLX5Ur3PHFZyps" || '';
}

function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);
  for (var i = 0; i < rawData.length; i++) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PushSetup',
  components: {
    'ios-install-guide': __WEBPACK_IMPORTED_MODULE_3__IOSInstallGuide___default.a
  },
  data: function data() {
    return {
      isSupported: false,
      isConfigured: true,
      isSubscribed: false,
      permissionState: 'default',
      subscribing: false,
      devices: [],
      error: '',
      showIOSGuide: false,
      canInstallAndroid: false,
      justBecameStandalone: false
    };
  },

  computed: {
    isIOS: function isIOS() {
      return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
      );
    },
    isStandalone: function isStandalone() {
      return window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
    },
    needsIOSInstall: function needsIOSInstall() {
      return this.isIOS && !this.isStandalone;
    }
  },
  methods: {
    loadDevices: function loadDevices() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__data_push_repository__["a" /* default */].getSubscriptions();

              case 3:
                _this.devices = _context.sent;
                _context.next = 8;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](0);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    checkSubscription: function checkSubscription() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var reg, sub;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!('serviceWorker' in navigator) || !('PushManager' in window))) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return navigator.serviceWorker.ready;

              case 5:
                reg = _context2.sent;
                _context2.next = 8;
                return reg.pushManager.getSubscription();

              case 8:
                sub = _context2.sent;

                _this2.isSubscribed = !!sub;
                _context2.next = 14;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](2);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 12]]);
      }))();
    },
    subscribe: function subscribe() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var vapidKey, reg, sub, subJson;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.error = '';
                vapidKey = getVapidPublicKey();

                if (vapidKey) {
                  _context3.next = 5;
                  break;
                }

                _this3.isConfigured = false;
                return _context3.abrupt('return');

              case 5:
                _this3.subscribing = true;
                _context3.prev = 6;
                _context3.next = 9;
                return navigator.serviceWorker.ready;

              case 9:
                reg = _context3.sent;
                _context3.next = 12;
                return reg.pushManager.subscribe({
                  userVisibleOnly: true,
                  applicationServerKey: urlBase64ToUint8Array(vapidKey)
                });

              case 12:
                sub = _context3.sent;
                subJson = sub.toJSON();
                _context3.next = 16;
                return __WEBPACK_IMPORTED_MODULE_2__data_push_repository__["a" /* default */].subscribe({
                  endpoint: subJson.endpoint,
                  p256dh: subJson.keys.p256dh,
                  auth: subJson.keys.auth
                });

              case 16:
                _this3.isSubscribed = true;
                _this3.permissionState = 'granted';
                _context3.next = 20;
                return _this3.loadDevices();

              case 20:
                _this3.$emit('subscribed');
                _context3.next = 26;
                break;

              case 23:
                _context3.prev = 23;
                _context3.t0 = _context3['catch'](6);

                if (Notification.permission === 'denied') {
                  _this3.permissionState = 'denied';
                } else {
                  _this3.error = 'Could not enable push notifications. Please try again.';
                }

              case 26:
                _this3.subscribing = false;

              case 27:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[6, 23]]);
      }))();
    },
    removeDevice: function removeDevice(device) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__data_push_repository__["a" /* default */].unsubscribe(device.endpoint);

              case 3:
                _this4.devices = _this4.devices.filter(function (d) {
                  return d.id !== device.id;
                });
                _context4.next = 6;
                return _this4.checkSubscription();

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](0);

                _this4.error = 'Could not remove device. Please try again.';

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 8]]);
      }))();
    },
    deviceLabel: function deviceLabel(device) {
      var label = 'Device ' + (this.devices.indexOf(device) + 1);
      if (device.user_agent) {
        if (device.user_agent.indexOf('iPhone') > -1) label = 'iPhone';else if (device.user_agent.indexOf('iPad') > -1) label = 'iPad';else if (device.user_agent.indexOf('Android') > -1) label = 'Android';else if (device.user_agent.indexOf('Mac') > -1) label = 'Mac';else if (device.user_agent.indexOf('Windows') > -1) label = 'Windows';else if (device.user_agent.indexOf('Linux') > -1) label = 'Linux';
      }
      var linked = this.linkedDate(device.created_at);
      return linked ? label + ' - ' + linked : label;
    },
    linkedDate: function linkedDate(createdAt) {
      var parts = String(createdAt || '').slice(0, 10).split('-');
      if (parts.length !== 3) return '';
      return parseInt(parts[1], 10) + '/' + parseInt(parts[2], 10) + '/' + parts[0].slice(2);
    },
    installAndroid: function installAndroid() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!window.deferredInstallPrompt) {
                  _context5.next = 7;
                  break;
                }

                window.deferredInstallPrompt.prompt();
                _context5.next = 4;
                return window.deferredInstallPrompt.userChoice;

              case 4:
                result = _context5.sent;

                if (result.outcome === 'accepted') {
                  _this5.canInstallAndroid = false;
                }
                window.deferredInstallPrompt = null;

              case 7:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  },
  mounted: function mounted() {
    var hasPushApi = 'serviceWorker' in navigator && 'PushManager' in window;
    this.isSupported = hasPushApi || this.isIOS && !this.isStandalone;
    if (!this.isSupported) return;

    this.isConfigured = getVapidPublicKey().length > 0;
    if (!this.isConfigured) return;

    this.permissionState = 'Notification' in window ? Notification.permission : 'default';
    this.canInstallAndroid = !!window.deferredInstallPrompt;

    if (this.isStandalone && this.isIOS) {
      this.justBecameStandalone = true;
    }

    this.checkSubscription();
    this.loadDevices();
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  },

  computed: {
    isLogin: function isLogin() {
      return this.$route.name === 'login';
    }
  },
  methods: {
    scrollToTop: function scrollToTop() {
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        window.scrollTo(0, 0);
      }
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CartIcon_vue__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CartIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CartIcon_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CartIcon: __WEBPACK_IMPORTED_MODULE_0__CartIcon_vue___default.a
  },
  data: function data() {
    return {};
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    logout: function logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    adClient: {
      type: String,
      required: true
    },
    adSlot: {
      type: String,
      required: true
    },
    adFormat: {
      type: String,
      required: false,
      default: 'auto'
    },
    adStyle: {
      type: String,
      required: false,
      default: 'display: block'
    },
    adLayoutKey: {
      type: String,
      required: false,
      default: ''
    }
  },
  mounted: function mounted() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['package', 'size', 'color'],
  data: function data() {
    return {
      id: -1,
      mutableSize: this.size || 'small',
      mutableColor: this.color || 'silver'
    };
  },

  computed: {
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    },
    packageId: function packageId() {
      return this.package.id;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.id = 'p' + this._uid;
    var that = this;
    this.$nextTick(function () {
      paypal.Button.render({
        env: '' + 'production',
        style: {
          size: _this.mutableSize,
          shape: 'rect',
          color: _this.mutableColor
        },
        commit: true,
        payment: function payment(resolve, reject) {
          var CREATE_PAYMENT_URL = 'https://rocky-savannah-28401.herokuapp.com/api/v1' + '/payment';
          paypal.request.post(CREATE_PAYMENT_URL, { id: that.packageId, userID: that.currentUser.id }).then(function (data) {
            resolve(data.paymentID);
          }).catch(function (err) {
            reject(err);
          });
        },
        onAuthorize: function onAuthorize(data, actions) {
          var EXECUTE_PAYMENT_URL = 'https://rocky-savannah-28401.herokuapp.com/api/v1' + '/payment/execute';
          paypal.request.post(EXECUTE_PAYMENT_URL, { paymentID: data.paymentID, payerID: data.payerID, userID: that.currentUser.id, packageID: that.packageId }).then(function (data) {
            that.$router.push('/picks');
          }).catch(function (err) {
            console.log(err);
          });
        }
      }, '#' + _this.id);
    });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  props: ['package', 'color', 'fullWidth'],
  data: function data() {
    return {
      mutableColor: this.color || 'grey',
      mutableFullWidth: this.fullWidth || false
    };
  },

  computed: {
    computedStyle: function computedStyle() {
      return {
        margin: this.mutableFullWidth ? 'none' : '8px auto'
      };
    },
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.currentUser || !this.currentUser.id) {
        return this.$router.push('/register');
      }
      this.$store.dispatch('setCurrentPackage', this.package);
      this.$router.push('/purchase');
    }
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_0__components_Nav___default.a
  },
  data: function data() {
    return {};
  },

  metaInfo: {
    title: 'Admin'
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_adsense_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_adsense_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_1__components_Nav___default.a,
    'adsense': __WEBPACK_IMPORTED_MODULE_2__components_adsense_vue___default.a
  },
  data: function data() {
    return {
      category: '',
      posts: [],
      page: 0,
      total: 0,
      current: 0
    };
  },

  methods: {
    next: function next() {
      var _this = this;

      if (this.current >= this.total && this.page !== 0) return;
      __WEBPACK_IMPORTED_MODULE_0__data_post_repository_js__["a" /* default */].get(this.page + 1, this.category, this.month, this.year).then(function (data) {
        _this.total = data.total;
        _this.current = data.to;
        _this.page = data.current_page;
        _this.posts = _this.posts.concat(data.data);
      });
    }
  },
  created: function created() {
    this.next();
  },

  metaInfo: {
    title: 'Blog'
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_paypalButton__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_paypalButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_paypalButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_purchaseButton__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_purchaseButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_purchaseButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(35);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_0__components_Nav___default.a,
    'paypal-button': __WEBPACK_IMPORTED_MODULE_1__components_paypalButton___default.a,
    'purchase-button': __WEBPACK_IMPORTED_MODULE_2__components_purchaseButton___default.a
  },
  computed: {
    packages: function packages() {
      var _this = this;

      return this.$store.state.packages.filter(function (p) {
        return p.sports_id === _this.selectedSport && !p.special;
      });
    },
    allWeek: function allWeek() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].ALL_ONE);
    },
    allWeekPrice: function allWeekPrice() {
      return this.allWeek ? this.allWeek.current_price : '';
    },
    allYear: function allYear() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].ALL_YEAR);
    },
    allYearPrice: function allYearPrice() {
      return this.allYear ? this.allYear.current_price : '';
    },
    allTwo: function allTwo() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].ALL_TWO);
    },
    allTwoPrice: function allTwoPrice() {
      return this.allTwo ? this.allTwo.current_price : '';
    },
    allMonth: function allMonth() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].ALL_MONTH);
    },
    allMonthPrice: function allMonthPrice() {
      return this.allMonth ? this.allMonth.current_price : '';
    },
    nhlFull: function nhlFull() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].NHL_FULL);
    },
    nflFull: function nflFull() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].NFL_FULL);
    },
    ncaafFull: function ncaafFull() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].NCAAF_FULL);
    },
    nbaFull: function nbaFull() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].NBA_FULL);
    },
    ncaabFull: function ncaabFull() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].NCAAB_FULL);
    },
    mlbFull: function mlbFull() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].MLB_FULL);
    }
  },
  data: function data() {
    return {
      month: new Date().getMonth(),
      selectedSport: '2343a835-82ae-4b4b-bb50-689912b97571'
    };
  },

  methods: {
    onSportChange: function onSportChange(evt) {
      this.selectedSport = evt.target.value;
    }
  },
  metaInfo: {
    title: 'Buy Picks'
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Nav__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Cart',
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_2__components_Nav___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['cart', 'isAuthenticated']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['cartItemCount', 'cartTotal'])),
  methods: {
    incrementQuantity: function incrementQuantity(item) {
      this.$store.dispatch('updateCartItem', {
        variantId: item.variantId,
        quantity: item.quantity + 1
      });
    },
    decrementQuantity: function decrementQuantity(item) {
      if (item.quantity > 1) {
        this.$store.dispatch('updateCartItem', {
          variantId: item.variantId,
          quantity: item.quantity - 1
        });
      }
    },
    updateQuantity: function updateQuantity(item) {
      if (item.quantity < 1) {
        item.quantity = 1;
      }
      this.$store.dispatch('updateCartItem', {
        variantId: item.variantId,
        quantity: item.quantity
      });
    },
    removeItem: function removeItem(item) {
      if (confirm('Remove ' + item.name + ' from cart?')) {
        this.$store.dispatch('removeFromCart', item.variantId);
      }
    },
    formatPrice: function formatPrice(price) {
      return price.toFixed(2);
    }
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_auth_repository__ = __webpack_require__(22);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_0__components_Nav___default.a
  },
  data: function data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: ''
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      var obj = { oldPassword: this.oldPassword, newPassword: this.newPassword, confirmPassword: this.confirmPassword, id: this.user.id };
      __WEBPACK_IMPORTED_MODULE_1__data_auth_repository__["a" /* default */].changePassword(obj).then(function (result) {
        _this.$router.push('/myaccount');
      }).catch(function (e) {
        if (e.response && e.response.data && e.response.data.error) {
          _this.error = e.response.data.error;
        }
      });
    }
  },
  computed: {
    user: function user() {
      return this.$store.state.currentUser;
    }
  },
  metaInfo: {
    title: 'Change Password'
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_product_repository__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Nav__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Checkout',
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_6__components_Nav___default.a
  },
  data: function data() {
    return {
      shipping: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        address_line1: '',
        address_line2: '',
        city: '',
        state: '',
        postal_code: '',
        country: 'US'
      },
      processing: false,
      processingMessage: '',
      error: null,
      orderCreated: false,
      currentOrderId: null,
      cardField: null,
      cardSubmitDisabled: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['cart', 'isAuthenticated', 'currentUser']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['cartTotal', 'cartItemCount'])),
  mounted: function mounted() {
    var _createOrder = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var cartData, shippingData, response, errorMessage;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (that.validateForm()) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Please fill in all required fields');

              case 2:
                _context.prev = 2;
                cartData = that.cart.map(function (item) {
                  return {
                    variant_id: item.variantId,
                    quantity: item.quantity,
                    price: item.price
                  };
                });
                shippingData = {
                  name: (that.shipping.first_name + ' ' + that.shipping.last_name).trim(),
                  email: that.shipping.email,
                  phone: that.shipping.phone,
                  address1: that.shipping.address_line1,
                  address2: that.shipping.address_line2,
                  city: that.shipping.city,
                  state: that.shipping.state,
                  postal_code: that.shipping.postal_code,
                  country: that.shipping.country
                };
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_5__data_product_repository__["a" /* default */].createOrder({
                  cart: cartData,
                  shipping: shippingData
                });

              case 7:
                response = _context.sent;


                console.log('Create order response:', response);

                if (!response.paypal_order_id) {
                  _context.next = 14;
                  break;
                }

                that.currentOrderId = response.order_id;
                return _context.abrupt('return', response.paypal_order_id);

              case 14:
                errorMessage = 'Failed to create PayPal order';

                console.error(errorMessage, response);
                throw new Error(errorMessage);

              case 17:
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](2);

                console.error('Create order error:', _context.t0);
                that.error = 'There was an issue processing your payment';
                throw _context.t0;

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 19]]);
      }));

      return function _createOrder() {
        return _ref.apply(this, arguments);
      };
    }();

    var _onApprove = function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(data) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('_onApprove called with data:', data);
                that.processingMessage = 'Processing payment...';

                _context2.prev = 2;

                console.log('Capturing payment for order ID:', that.currentOrderId);
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__data_product_repository__["a" /* default */].captureOrder(that.currentOrderId);

              case 6:

                console.log('Payment captured successfully');
                that.processingMessage = 'Payment successful! Redirecting...';

                that.$store.dispatch('clearCart');

                that.$router.push('/order-confirmation/' + that.currentOrderId);
                _context2.next = 19;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](2);

                that.processing = false;
                that.error = _context2.t0.response && _context2.t0.response.data && _context2.t0.response.data.message || 'Payment capture failed. Please contact support.';
                console.error('Capture payment error:', _context2.t0);
                console.error('Capture error response:', _context2.t0.response);
                throw _context2.t0;

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 12]]);
      }));

      return function _onApprove(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    if (!this.isAuthenticated) {
      this.$router.push('/login');
      return;
    }

    if (this.currentUser && this.currentUser.email) {
      this.shipping.email = this.currentUser.email;
    }

    var that = this;

    this.$nextTick(function () {
      paypal.Buttons({
        createOrder: _createOrder,
        onApprove: _onApprove,
        onError: function onError(err) {
          that.processing = false;
          that.error = 'Payment failed. Please try again.';
          console.error('PayPal error:', err);
        },
        style: {
          shape: 'rect',
          layout: 'vertical',
          color: 'gold',
          label: 'paypal'
        }
      }).render('#paypal-button-container');

      that.cardField = paypal.CardFields({
        createOrder: _createOrder,
        onApprove: _onApprove,
        style: {
          input: {
            'font-size': '16px',
            'font-family': 'helvetica, tahoma, calibri, sans-serif',
            color: '#333333'
          },
          '.invalid': { color: 'red' }
        }
      });

      if (that.cardField.isEligible()) {
        var nameField = that.cardField.NameField();
        nameField.render('#card-name-field-container');

        var numberField = that.cardField.NumberField();
        numberField.render('#card-number-field-container');

        var cvvField = that.cardField.CVVField();
        cvvField.render('#card-cvv-field-container');

        var expiryField = that.cardField.ExpiryField();
        expiryField.render('#card-expiry-field-container');
      } else {
        that.error = 'Card fields are not available at this time. Please reach out to support@stumpthespread.com';
      }
    });
  },

  methods: {
    submitCardPayment: function submitCardPayment() {
      var _this = this;

      if (this.cardSubmitDisabled) return;

      if (!this.validateForm()) {
        return;
      }

      this.cardSubmitDisabled = true;
      this.error = null;

      this.cardField.submit({}).then(function (data) {
        console.log(data);
      }).catch(function (err) {
        console.error('Card payment error:', err);

        if (err.message && err.message.indexOf('DECLINED') > -1) {
          _this.error = 'Payment declined. Please check your card details and try again.';
        } else if (err.message === 'INVALID_NUMBER') {
          _this.error = 'Invalid card number. Please check and try again.';
        } else if (err.message === 'INVALID_EXPIRY') {
          _this.error = 'Invalid expiration date. Please check and try again.';
        } else if (err.message === 'INVALID_CVV') {
          _this.error = 'Invalid CVV. Please check and try again.';
        } else {
          _this.error = err.message || 'Payment failed. Please check your card details and try again.';
        }
      }).finally(function () {
        _this.cardSubmitDisabled = false;
      });
    },
    validateForm: function validateForm() {
      var required = ['first_name', 'last_name', 'email', 'address_line1', 'city', 'state', 'postal_code', 'country'];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(required), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          if (!this.shipping[field] || this.shipping[field].trim() === '') {
            this.error = 'Please fill in all required fields';
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.shipping.email)) {
        this.error = 'Please enter a valid email address';
        return false;
      }

      return true;
    },
    formatPrice: function formatPrice(price) {
      return price.toFixed(2);
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_contact_repository__ = __webpack_require__(107);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    navigation: __WEBPACK_IMPORTED_MODULE_0__components_Nav_vue___default.a
  },
  data: function data() {
    return {
      success: false,
      contact: {
        from: '',
        name: '',
        message: ''
      }
    };
  },

  methods: {
    send: function send() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        __WEBPACK_IMPORTED_MODULE_1__data_contact_repository__["a" /* default */].send(_this.contact).then(function (result) {
          _this.success = true;
        }).catch(function () {
          return console.log('An error has occurred');
        });
      });
    }
  },
  metaInfo: {
    title: 'Contact'
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_auth_repository_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_1__components_Nav___default.a
  },
  data: function data() {
    return {
      sent: false,
      email: '',
      error: ''
    };
  },

  methods: {
    sendForgot: function sendForgot() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        __WEBPACK_IMPORTED_MODULE_0__data_auth_repository_js__["a" /* default */].resetPassword(_this.email).then(function (user) {
          _this.sent = true;
          _this.error = '';
        }).catch(function (e) {
          if (e.response && e.response.data) {
            var str = '';
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forOwn(e.response.data, function (value, key) {
              str += value.join(', ');
            });
            _this.error = str;
          }
        }).catch(function () {
          _this.error = 'An error has occurred';
        });
      });
    }
  },
  metaInfo: {
    title: 'Forgot Password'
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_0__components_Nav_vue___default.a
  },
  data: function data() {
    return {};
  },

  metaInfo: {
    title: 'Help'
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('getStoredUser').then(function () {
      if (!_this.$store.state.currentUser < 0) _this.$router.push('/login');
    });
    this.$store.dispatch('getPackages');
  },

  computed: {
    user: function user() {
      return this.$store.state.currentUser;
    }
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      error: '',
      package: '',
      cookiesEnabled: true
    };
  },
  mounted: function mounted() {
    this.package = this.$route.query.package;
    var savedUsername = '';
    try {
      savedUsername = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('sts_username');
    } catch (e) {
      this.cookiesEnabled = false;
      console.log(e);
    }
    if (savedUsername) {
      this.username = savedUsername;
    }
  },

  methods: {
    login: function login() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        _this.$store.dispatch('login', { email: _this.username, password: _this.password }).then(function (user) {
          if (_this.cookiesEnabled) {
            __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('sts_username', _this.username, { expires: 120 });
          }
          if (_this.package) {
            _this.$router.push({ path: '/purchase', query: { package: _this.package } });
          } else {
            _this.$router.push('/');
          }
        }).catch(function () {
          _this.error = 'Login failed...';
        });
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  metaInfo: {
    title: 'Login'
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_record_repository_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_0__components_Nav___default.a
  },
  data: function data() {
    return {
      total: 0,
      current: 0,
      page: 0,
      records: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__data_record_repository_js__["a" /* default */].get(this.page + 1).then(function (data) {
      _this.total = data.total;
      _this.current = data.to;
      _this.page = data.current_page;
      _this.records = data.data;
    });
  },

  methods: {
    next: function next() {
      var _this2 = this;

      if (this.current >= this.total && this.page !== 0) return;
      __WEBPACK_IMPORTED_MODULE_1__data_record_repository_js__["a" /* default */].get(this.page + 1).then(function (data) {
        _this2.total = data.total;
        _this2.current = data.to;
        _this2.page = data.current_page;
        _this2.records = _this2.records.concat(data.data);
      });
    },
    remove: function remove(record) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__data_record_repository_js__["a" /* default */].remove(record).then(function (result) {
        var index = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(_this3.records, record);
        _this3.records.splice(index, 1);
      }).catch(function (e) {
        return console.log(e);
      });
    },
    update: function update(record, result) {
      record.result = result;
      __WEBPACK_IMPORTED_MODULE_1__data_record_repository_js__["a" /* default */].save(record).then(function (result) {
        console.log('saved');
      }).catch(function (e) {
        return console.log(e);
      });
    }
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PushSetup__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PushSetup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PushSetup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_auth_repository__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_0__components_Nav___default.a,
    'push-setup': __WEBPACK_IMPORTED_MODULE_1__components_PushSetup___default.a
  },
  computed: {
    user: function user() {
      return this.$store.state.currentUser;
    }
  },
  data: function data() {
    return {
      notifyEmail: false,
      notifyPush: false,
      notifySms: false,
      pushSaveError: '',
      contactEmail: '',
      contactPhone: '',
      phone: {},
      phoneOpts: [{ key: 'Select Carrier', value: 0 }, { key: 'Verizon', value: 2 }, { key: 'T-Mobile', value: 3 }, { key: 'Sprint', value: 4 }, { key: 'U.S. Cellular', value: 5 }, { key: 'Virgin Mobile', value: 6 }, { key: 'Tracfone', value: 7 }, { key: 'Metro PCS', value: 8 }, { key: 'Boost Mobile', value: 9 }, { key: 'Cricket', value: 10 }, { key: 'Nextel', value: 11 }, { key: 'Alltel', value: 12 }, { key: 'Ptel', value: 13 }, { key: 'Suncom', value: 14 }, { key: 'Qwest', value: 15 }]
    };
  },

  methods: {
    onDeviceSubscribed: function onDeviceSubscribed() {
      var _this = this;

      this.pushSaveError = '';
      this.notifyPush = true;
      var payload = {
        id: this.user.id,
        email: this.user.email,
        notify_push: 1
      };
      __WEBPACK_IMPORTED_MODULE_2__data_auth_repository__["a" /* default */].save(payload).then(function () {
        _this.$store.dispatch('getStoredUser');
      }).catch(function () {
        _this.pushSaveError = 'Your device is registered, but we could not turn on push automatically. Please tap Save.';
      });
    },
    save: function save() {
      var _this2 = this;

      var payload = {
        id: this.user.id,
        email: this.user.email,
        notify_email: this.notifyEmail ? 1 : 0,
        notify_push: this.notifyPush ? 1 : 0,
        notify_sms: this.notifySms ? 1 : 0,
        contact_method: this.notifySms ? 2 : this.notifyEmail ? 1 : 0,
        contact_email: this.notifyEmail ? this.contactEmail : this.notifySms ? this.contactPhone : '',
        contact_phone: this.notifySms ? this.phone.value || 0 : 0
      };
      __WEBPACK_IMPORTED_MODULE_2__data_auth_repository__["a" /* default */].save(payload).then(function (result) {
        _this2.$store.dispatch('getStoredUser');
        _this2.$router.push('/');
      }).catch(function () {
        return console.log('An error occurred');
      });
    }
  },
  mounted: function mounted() {
    var u = this.$store.state.currentUser;
    if (!u || !u.id) return this.$router.push('/login');
    if (u.notify_email !== undefined) {
      this.notifyEmail = !!u.notify_email;
    } else {
      this.notifyEmail = u.contact_method === 1;
    }
    if (u.notify_push !== undefined) {
      this.notifyPush = !!u.notify_push;
    }
    if (u.notify_sms !== undefined) {
      this.notifySms = !!u.notify_sms;
    } else {
      this.notifySms = u.contact_method === 2;
    }

    if (u.contact_method === 1 && u.contact_email) {
      this.contactEmail = u.contact_email;
    } else if (u.email) {
      this.contactEmail = u.email;
    }
    if (u.contact_method === 2 && u.contact_email) {
      this.contactPhone = u.contact_email;
    }

    if (!u.contact_phone || u.contact_phone === 0) {
      this.phone = this.phoneOpts[0];
    } else if (u.contact_phone) {
      this.phone = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.phoneOpts, ['value', u.contact_phone]) || this.phoneOpts[0];
    }
  },

  metaInfo: {
    title: 'My Account'
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_product_repository__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Nav__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MyOrders',
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_3__components_Nav___default.a
  },
  data: function data() {
    return {
      orders: [],
      loading: false,
      error: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['isAuthenticated', 'currentUser'])),
  mounted: function mounted() {
    if (!this.isAuthenticated) {
      this.$router.push('/login');
      return;
    }
    this.loadOrders();
  },

  methods: {
    loadOrders: function loadOrders() {
      var _this = this;

      this.loading = true;
      this.error = null;

      __WEBPACK_IMPORTED_MODULE_2__data_product_repository__["a" /* default */].getUserOrders().then(function (orders) {
        _this.orders = orders;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        _this.error = 'Failed to load orders. Please try again.';
        console.error('Error loading orders:', err);
      });
    },
    viewOrder: function viewOrder(orderId) {
      this.$router.push('/order-confirmation/' + orderId);
    },
    getPrimaryImage: function getPrimaryImage(product) {
      if (!product.images || product.images.length === 0) return null;
      return product.images.find(function (img) {
        return img.is_primary === 1;
      }) || product.images[0];
    },
    formatPrice: function formatPrice(cents) {
      return (cents / 100).toFixed(2);
    },
    formatStatus: function formatStatus(status) {
      return status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ');
    },
    formatDate: function formatDate(dateString) {
      var date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_product_repository__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Nav__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrderConfirmation',
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_3__components_Nav___default.a
  },
  data: function data() {
    return {
      order: null,
      loading: false,
      error: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['isAuthenticated'])),
  mounted: function mounted() {
    this.loadOrder();
  },

  methods: {
    loadOrder: function loadOrder() {
      var _this = this;

      this.loading = true;
      this.error = null;

      var orderId = this.$route.params.id;

      if (!orderId) {
        this.loading = false;
        this.error = 'Order not found';
        return;
      }

      __WEBPACK_IMPORTED_MODULE_2__data_product_repository__["a" /* default */].getOrder(orderId).then(function (order) {
        _this.order = order;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        _this.error = 'Order not found or you do not have permission to view this order';
        console.error('Error loading order:', err);
      });
    },
    getPrimaryImage: function getPrimaryImage(product) {
      if (!product.images || product.images.length === 0) return null;
      return product.images.find(function (img) {
        return img.is_primary === 1;
      }) || product.images[0];
    },
    formatPrice: function formatPrice(cents) {
      return (cents / 100).toFixed(2);
    },
    formatStatus: function formatStatus(status) {
      return status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ');
    },
    formatDate: function formatDate(dateString) {
      var date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_pick_repository_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_adsense_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_adsense_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_purchaseButton__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_purchaseButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_purchaseButton__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_0__components_Nav_vue___default.a,
    'adsense': __WEBPACK_IMPORTED_MODULE_2__components_adsense_vue___default.a,

    'purchase-button': __WEBPACK_IMPORTED_MODULE_4__components_purchaseButton___default.a
  },
  data: function data() {
    return {
      picks: null,
      selectedSport: 'All'
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__data_pick_repository_js__["a" /* default */].getPremium().then(function (p) {
      _this.picks = p;
    });
  },

  methods: {
    sportName: function sportName(pick) {
      return pick && pick.sport && pick.sport.sport || 'Other';
    },
    sportLabel: function sportLabel(value) {
      if (value === 'NCAAF') return 'CFB';
      if (value === 'NCAAB') return 'CBB';
      return value;
    },
    selectSport: function selectSport(value) {
      this.selectedSport = value;
    }
  },
  computed: {
    sportOptions: function sportOptions() {
      var _this2 = this;

      var seen = {};
      var options = ['All'];(this.picks || []).forEach(function (p) {
        var name = _this2.sportName(p);
        if (!seen[name]) {
          seen[name] = true;
          options.push(name);
        }
      });
      return options;
    },
    filteredPicks: function filteredPicks() {
      var _this3 = this;

      if (!this.picks || this.selectedSport === 'All') return this.picks || [];
      return this.picks.filter(function (p) {
        return _this3.sportName(p) === _this3.selectedSport;
      });
    },
    user: function user() {
      return this.$store.state.currentUser;
    },
    allYear: function allYear() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].ALL_YEAR);
    },
    allMonth: function allMonth() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].ALL_MONTH);
    },
    allTwo: function allTwo() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].ALL_TWO);
    },
    allWeek: function allWeek() {
      return this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* PACKAGES */].ALL_ONE);
    }
  },
  metaInfo: {
    title: 'Picks'
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_product_repository__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Nav__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProductDetail',
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_5__components_Nav___default.a
  },
  data: function data() {
    return {
      product: null,
      loading: false,
      error: null,
      selectedImage: null,
      selectedColor: null,
      selectedSize: null,
      quantity: 1,
      addedToCart: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['isAuthenticated']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['cartItemCount']), {
    availableColors: function availableColors() {
      if (!this.product || !this.product.variants) return [];
      var colors = this.product.variants.filter(function (v) {
        return v.active === 1 && v.color;
      }).map(function (v) {
        return v.color;
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(colors)));
    },
    availableSizes: function availableSizes() {
      if (!this.product || !this.product.variants) return [];
      var sizes = this.product.variants.filter(function (v) {
        return v.active === 1 && v.size;
      }).map(function (v) {
        return v.size;
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(sizes)));
    },
    selectedVariant: function selectedVariant() {
      var _this = this;

      if (!this.product || !this.product.variants) return null;

      return this.product.variants.find(function (v) {
        var colorMatch = !_this.selectedColor || v.color === _this.selectedColor;
        var sizeMatch = !_this.selectedSize || v.size === _this.selectedSize;
        return v.active === 1 && colorMatch && sizeMatch;
      });
    },
    currentPrice: function currentPrice() {
      if (!this.product) return 0;

      if (this.product.is_on_sale && this.product.sale_price_cents !== null) {
        return this.product.sale_price_cents;
      }

      if (this.selectedVariant && this.selectedVariant.price_modifier_cents) {
        return this.product.base_price_cents + this.selectedVariant.price_modifier_cents;
      }

      return this.product.base_price_cents;
    },
    regularPrice: function regularPrice() {
      if (!this.product) return 0;

      if (this.selectedVariant && this.selectedVariant.price_modifier_cents) {
        return this.product.base_price_cents + this.selectedVariant.price_modifier_cents;
      }

      return this.product.base_price_cents;
    }
  }),
  mounted: function mounted() {
    this.loadProduct();
  },

  methods: {
    loadProduct: function loadProduct() {
      var _this2 = this;

      this.loading = true;
      this.error = null;

      var slug = this.$route.params.slug;

      __WEBPACK_IMPORTED_MODULE_4__data_product_repository__["a" /* default */].getBySlug(slug).then(function (product) {
        _this2.product = product;
        _this2.loading = false;

        if (product.images && product.images.length > 0) {
          _this2.selectedImage = product.images.find(function (img) {
            return img.is_primary === 1;
          }) || product.images[0];
        }

        if (_this2.availableColors.length > 0) {
          _this2.selectedColor = _this2.availableColors[0];
        }
        if (_this2.availableSizes.length > 0) {
          _this2.selectedSize = _this2.availableSizes[0];
        }
      }).catch(function (err) {
        _this2.loading = false;
        _this2.error = 'Product not found';
        console.error('Error loading product:', err);
      });
    },
    addToCart: function addToCart() {
      if (!this.selectedVariant) {
        alert('Please select all options');
        return;
      }

      if (!this.isAuthenticated) {
        this.$router.push('/login');
        return;
      }

      var cartItem = {
        variantId: this.selectedVariant.id,
        productId: this.product.id,
        quantity: this.quantity,
        price: this.currentPrice / 100,
        name: this.product.name,
        size: this.selectedVariant.size,
        color: this.selectedVariant.color,
        image: this.selectedImage ? this.selectedImage.image_url : null,
        isOnSale: this.product.is_on_sale || false
      };

      this.$store.dispatch('addToCart', cartItem);

      this.addedToCart = true;
    },
    incrementQuantity: function incrementQuantity() {
      this.quantity++;
    },
    decrementQuantity: function decrementQuantity() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },
    formatPrice: function formatPrice(cents) {
      return (cents / 100).toFixed(2);
    }
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Nav_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Nav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_purchase_repository__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(35);










var ALL_SPORTS_ID = '2343a835-82ae-4b4b-bb50-689912b97571';

var FALLBACK_PACKAGE = { id: __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* PACKAGES */].ALL_MONTH, current_price: '129', sports_id: ALL_SPORTS_ID };

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_4__components_Nav_vue___default.a
  },
  data: function data() {
    return {
      errorMessage: '',
      purchaseDisabled: false,
      selectedSport: '2343a835-82ae-4b4b-bb50-689912b97571'
    };
  },
  mounted: function mounted() {
    var _this = this;

    var _onApprove = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(data, actions) {
        var response, orderData, purchaseUnit, payments, transaction, serverData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__data_purchase_repository__["a" /* default */].capture(data);

              case 3:
                response = _context.sent;

                console.log(response);

                orderData = response.data;
                purchaseUnit = orderData.purchase_units && orderData.purchase_units[0] || null;
                payments = purchaseUnit ? purchaseUnit.payments : null;
                transaction = payments ? payments.captures && payments.captures[0] || payments.authorizations && payments.authorizations[0] : null;

                if (!(transaction && transaction.status === 'DECLINED')) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return', _setErrorMessage('Your card was declined. Please try a different payment method.'));

              case 11:
                return _context.abrupt('return', _routeToSuccess());

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](0);

                console.log('error on approve');
                serverData = _context.t0.response && _context.t0.response.data;

                _setErrorMessage(serverData && (serverData.error || serverData.msg) || 'There was an issue processing your payment');

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 14]]);
      }));

      return function _onApprove(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    var _createOrder = function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(data) {
        var orderData, errorDetail, errorMessage, authMessage, serverData, message;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__data_purchase_repository__["a" /* default */].create({
                  cart: [{
                    id: that.dataPackage.id,
                    quantity: 1,
                    price: that.dataPackage.current_price
                  }]
                });

              case 3:
                orderData = _context2.sent;

                if (!orderData.data.id) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return', orderData.data.id);

              case 8:
                errorDetail = orderData.data.details[0];
                errorMessage = errorDetail ? errorDetail.issue + ' ' + errorDetail.description + ' (' + orderData.data.debug_id + ')' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(orderData);
                throw new Error(errorMessage);

              case 11:
                _context2.next = 25;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](0);

                console.error(_context2.t0);

                if (!(_context2.t0.response && _context2.t0.response.status === 401)) {
                  _context2.next = 20;
                  break;
                }

                authMessage = 'Your session has expired. Please sign in again to complete your purchase.';

                _setErrorMessage(authMessage);
                throw new Error(authMessage);

              case 20:
                __WEBPACK_IMPORTED_MODULE_3_raven_js___default.a.captureException(_context2.t0, {
                  extra: {
                    packageId: that.dataPackage.id,
                    price: that.dataPackage.current_price
                  }
                });
                serverData = _context2.t0.response && _context2.t0.response.data;
                message = serverData && (serverData.error || serverData.msg) || 'There was an issue processing your payment';

                _setErrorMessage(message);
                throw new Error(message);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      return function _createOrder(_x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    var that = this;

    function _routeToSuccess() {
      that.$router.push('/picks');
    }

    function _setErrorMessage(message) {
      that.errorMessage = message;
    }
    this.$nextTick(function () {
      paypal.Buttons({
        createOrder: _createOrder,
        onApprove: _onApprove,
        onError: function onError(error) {
          console.error(error);
          this.errorMessage = error.message || 'There was an issue processing your payment';
        },
        funding: {
          disallowed: [paypal.FUNDING.CREDIT]
        },

        style: {
          shape: 'rect',
          layout: 'vertical',
          color: 'gold',
          label: 'paypal'
        },
        message: {
          amount: 100
        }
      }).render('#paypal-button-container');
      that.cardField = paypal.CardFields({
        createOrder: _createOrder,
        onApprove: _onApprove,
        style: {
          input: {
            'font-size': '16px',
            'font-family': 'courier, monospace',
            'font-weight': 'lighter',
            color: '#333333'
          },
          '.invalid': { color: 'red' }
        }
      });
      console.log('IsEligible ' + that.cardField.isEligible());
      if (that.cardField.isEligible()) {
        var nameField = that.cardField.NameField();
        nameField.render('#card-name-field-container');
        var numberField = that.cardField.NumberField();
        numberField.render('#card-number-field-container');
        var cvvField = that.cardField.CVVField({});
        cvvField.render('#card-cvv-field-container');
        var expiryField = that.cardField.ExpiryField({});
        expiryField.render('#card-expiry-field-container');
      } else {
        _this.errorMessage = 'Card fields are not available at this time. Please reach out to support@stumpthespread.com';
      }
    });
  },

  computed: {
    buttonText: function buttonText() {
      return this.currentUser ? 'Purchase $' + this.dataPackage.current_price : 'Log in to Purchase';
    },
    packageId: function packageId() {
      return this.dataPackage.id;
    },
    dataPackage: function dataPackage() {
      return this.getPackage();
    },
    packages: function packages() {
      var _this2 = this;

      return this.$store.state.packages.filter(function (p) {
        return p.sports_id === _this2.selectedSport && !p.special;
      });
    },
    currentUser: function currentUser() {
      return this.$store.state.currentUser;
    }
  },
  methods: {
    onSportChange: function onSportChange() {
      this.$store.commit('setCurrentPackage', this.packages[0]);
    },
    emitSelection: function emitSelection(evt) {
      this.$store.commit('setCurrentPackage', this.$store.getters.package(evt.target.value));
    },
    getPackage: function getPackage() {
      if (this.$store.state.currentPackage && this.$store.state.currentPackage.id) {
        if (this.$store.state.currentPackage.sports_id !== this.selectedSport) this.selectedSport = this.$store.state.currentPackage.sports_id;
        return this.$store.state.currentPackage;
      }
      var queryPackage = this.$route.query.package ? this.$store.getters.package(this.$route.query.package) : null;
      return queryPackage || this.$store.getters.package(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* PACKAGES */].ALL_MONTH) || FALLBACK_PACKAGE;
    },
    purchase: function purchase() {
      var _this3 = this;

      if (this.purchaseDisabled) return;
      console.log('purchase click');
      if (!this.currentUser || !this.currentUser.id) {
        return this.$router.push({ path: '/login', query: { package: this.dataPackage.id } });
      }
      this.purchaseDisabled = true;
      this.cardField.submit({}).then(function (data) {
        console.log(data);
      }).catch(function (error) {
        console.log(error.message);
        if (error.message.indexOf('DECLINED') > 0) {
          _this3.errorMessage = 'Payment issue: Card was declined';
        } else if (error.message === 'INVALID_NUMBER') {
          _this3.errorMessage = 'Payment issue: Invalid card number';
        } else if (error.message === 'INVALID_EXPIRY') {
          _this3.errorMessage = 'Payment issue: Invalid expiration date';
        } else if (error.message === 'INVALID_CVV') {
          _this3.errorMessage = 'Payment Issue: Invalid CVV';
        } else {
          _this3.errorMessage = error.message || 'There was an issue processing your payment';
        }
        console.error(error);
      }).finally(function () {
        _this3.purchaseDisabled = false;
      });
    }
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_auth_repository_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_1__components_Nav___default.a
  },
  data: function data() {
    return {
      registered: false,
      error: '',
      user: {
        fname: '',
        lname: '',
        email: '',
        password: '',
        confirmPassword: ''
      }
    };
  },

  methods: {
    signup: function signup() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        __WEBPACK_IMPORTED_MODULE_0__data_auth_repository_js__["a" /* default */].register(_this.user).then(function (user) {
          _this.registered = true;
          _this.error = '';
        }).catch(function (e) {
          if (e.response && e.response.data) {
            var str = '';
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forOwn(e.response.data, function (value, key) {
              str += value.join(', ');
            });
            _this.error = str;
          }
        }).catch(function () {
          _this.error = 'An error has occurred';
        });
      });
    }
  },
  metaInfo: {
    title: 'Register'
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StsFooter__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_StsFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_StsFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StsHeader__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_StsHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_StsHeader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    StsFooter: __WEBPACK_IMPORTED_MODULE_0__components_StsFooter___default.a,
    StsHeader: __WEBPACK_IMPORTED_MODULE_1__components_StsHeader___default.a
  },
  data: function data() {
    return {};
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('getStoredUser').then(function () {
      if (!_this.$store.state.currentUser && !_this.$route.path.indexOf('purchase') < 0) _this.$router.push('/login');
    });
    this.$store.dispatch('getPackages');
    this.$store.dispatch('loadCart');
  },

  metaInfo: {
    title: 'Home',

    titleTemplate: '%s | StumptheSpread.com',
    meta: [{ charset: 'utf-8' }, { name: 'viewport', content: 'width=device-width, initial-scale=1' }]
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Nav__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Shop',
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_2__components_Nav___default.a
  },
  data: function data() {
    return {
      loading: false,
      error: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['products'])),
  mounted: function mounted() {
    this.loadProducts();
  },

  methods: {
    loadProducts: function loadProducts() {
      var _this = this;

      this.loading = true;
      this.error = null;

      this.$store.dispatch('getProducts').then(function () {
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        _this.error = 'Failed to load products. Please try again later.';
        console.error('Error loading products:', err);
      });
    },
    viewProduct: function viewProduct(product) {
      this.$router.push('/shop/' + product.slug);
    },
    primaryImage: function primaryImage(product) {
      if (!product.images || product.images.length === 0) return null;
      return product.images.find(function (img) {
        return img.is_primary === 1;
      }) || product.images[0];
    },
    formatPrice: function formatPrice(cents) {
      return (cents / 100).toFixed(2);
    },
    truncateDescription: function truncateDescription(description) {
      if (!description) return '';
      return description.length > 100 ? description.substring(0, 100) + '...' : description;
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Nav_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Nav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Nav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_tool_repository__ = __webpack_require__(115);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_1__components_Nav_vue___default.a
  },
  data: function data() {
    return {
      multipliers: ['Conservative', 'Standard', 'Aggressive'],
      selectedMultiplier: 'Standard',
      bankroll: 1000,
      odds: '-150',
      edge: 5,
      optimal: { betSize: 0, percentage: 0 }
    };
  },

  methods: {
    multiplierChange: function multiplierChange() {
      this.optimal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.optimal, { betSize: 0, percentage: 0 });
    },
    calculate: function calculate() {
      var _this = this;

      return this.$validator.validateAll().then(function (result) {
        if (result) {
          var multiplier = _this.multipliers.indexOf(_this.selectedMultiplier);
          return __WEBPACK_IMPORTED_MODULE_2__data_tool_repository__["a" /* default */].size({ bankroll: _this.bankroll, line: Number(_this.odds), edge: _this.edge / 100, multiplier: multiplier }).then(function (response) {
            _this.optimal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.optimal, { betSize: response.optimal_bet, percentage: response.optimal_percentage });
            console.log(_this.optimal.betSize);
          });
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  computed: {
    showOptimalBetSize: function showOptimalBetSize() {
      console.log('updating optimal bet size ', this.optimal.betSize);
      console.log(this.optimal.betSize > 0);
      return this.optimal.betSize > 0;
    }
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_testimonial_repository__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_adsense_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_adsense_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_adsense_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'navigation': __WEBPACK_IMPORTED_MODULE_0__components_Nav___default.a,
    'adsense': __WEBPACK_IMPORTED_MODULE_2__components_adsense_vue___default.a
  },
  data: function data() {
    return {
      testimonials: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__data_testimonial_repository__["a" /* default */].getTestimonials().then(function (testimonials) {
      _this.testimonials = testimonials;
    });
  },

  metaInfo: {
    title: 'Testimonials'
  }
});

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  "data-v-4148bc56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(230)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(302),
  /* scopeId */
  "data-v-90b9bc3c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(235)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(307),
  /* scopeId */
  "data-v-d31545d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  "data-v-13a24f01",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(213)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  "data-v-34d4b2f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(228)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(300),
  /* scopeId */
  "data-v-7c696bfe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(284),
  /* scopeId */
  "data-v-2cebc247",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(293),
  /* scopeId */
  "data-v-55c7f95a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(283),
  /* scopeId */
  "data-v-2b5a41fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(229)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(301),
  /* scopeId */
  "data-v-7d9a55d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(222)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(294),
  /* scopeId */
  "data-v-5df3d0ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  "data-v-08e6d604",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  "data-v-012acad0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(216)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  "data-v-3ca75ad4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(291),
  /* scopeId */
  "data-v-4e23b179",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(223)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  "data-v-603bd817",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(227)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(299),
  /* scopeId */
  "data-v-75b7dd3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  "data-v-07de3464",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(232)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  "data-v-9dbf5e4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  "data-v-1fe6f42e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  "data-v-3abff0ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(220)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(292),
  /* scopeId */
  "data-v-51f40c2c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(225)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  "data-v-6f533098",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  "data-v-3671f739",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  "data-v-3e937fdb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(234)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(306),
  /* scopeId */
  "data-v-d1de76b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(224)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  "data-v-68a1daae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(233)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(305),
  /* scopeId */
  "data-v-a09b3b8e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(226)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(298),
  /* scopeId */
  "data-v-73da7f28",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), (!_vm.success) ? _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow"
  }, [_vm._v("Contact")]), _vm._v(" "), (_vm.errors.any()) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('name')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Please enter your name")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter a valid email")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('message')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("Please enter your message")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('form', {
    attrs: {
      "name": "contact"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.name),
      expression: "contact.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "name",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.contact.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.from),
      expression: "contact.from"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "email",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.contact.from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.from = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.message),
      expression: "contact.message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "text_area",
    attrs: {
      "cols": "5",
      "name": "message",
      "rows": "5",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.contact.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Submit",
      "name": "submitButton",
      "title": "Submit"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "menu_index"
    }
  }, [_c('h2', [_vm._v("Success!")]), _vm._v(" "), _c('br'), _vm._v("\nYour email has been sent. Thank you for contacting us!\n")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text_form"
  }, [_vm._v("\n        Name: "), _c('br'), _vm._v("\n        Email: "), _c('br'), _vm._v("\n        Message:\n      ")])
}]}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Manage Record")]), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, _vm._l((_vm.records), function(record) {
    return _c('li', [_c('div', {
      staticClass: "article"
    }, [_c('p', {
      staticClass: "text_article"
    }, [_vm._v(_vm._s(record.pick) + "    "), _c('b', [_vm._v(_vm._s(record.result))])]), _vm._v(" "), _c('b', [_vm._v(_vm._s(record.date))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript;"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(record)
        }
      }
    }, [_vm._v("Delete")]), _vm._v("\n             \n          "), _c('a', {
      attrs: {
        "href": "javascript;"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.update(record, 'W')
        }
      }
    }, [_vm._v("Win")]), _vm._v("\n             \n          "), _c('a', {
      attrs: {
        "href": "javascript;"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.update(record, 'L')
        }
      }
    }, [_vm._v("Loss")]), _vm._v("\n             \n          ")]), _vm._v(" "), _c('div', {
      staticClass: "separator"
    })])
  }))])], 1)
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "checkout-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Checkout")]), _vm._v(" "), (_vm.cart.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('p', [_vm._v("Your cart is empty. Please add items before checking out.")]), _vm._v(" "), _c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n          Back to Shop\n        ")])]) : _c('div', {
    staticClass: "checkout-content"
  }, [_c('div', {
    staticClass: "checkout-form"
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('h2', [_vm._v("Shipping Information")]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("First Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.first_name),
      expression: "shipping.first_name"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Last Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.last_name),
      expression: "shipping.last_name"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.last_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.email),
      expression: "shipping.email"
    }],
    attrs: {
      "type": "email",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.phone),
      expression: "shipping.phone"
    }],
    attrs: {
      "type": "tel",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Address Line 1 *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.address_line1),
      expression: "shipping.address_line1"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.address_line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.address_line1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Address Line 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.address_line2),
      expression: "shipping.address_line2"
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.address_line2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.address_line2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("City *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.city),
      expression: "shipping.city"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State/Province *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.state),
      expression: "shipping.state"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.state = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Postal Code *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.postal_code),
      expression: "shipping.postal_code"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.postal_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.postal_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Country *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.country),
      expression: "shipping.country"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.processing
    },
    domProps: {
      "value": (_vm.shipping.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.country = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n            " + _vm._s(_vm.error) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.processing) ? _c('div', {
    staticClass: "processing-message"
  }, [_vm._v("\n            " + _vm._s(_vm.processingMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.processing && !_vm.orderCreated) ? _c('div', [_c('div', {
    ref: "paypalButtons",
    staticClass: "paypal-button-container",
    attrs: {
      "id": "paypal-button-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Spacer-module_divider__ewqEj"
  }, [_c('span', [_vm._v("OR")])]), _vm._v(" "), _c('div', {
    staticClass: "card_container",
    attrs: {
      "id": "card-form"
    }
  }, [_c('div', {
    staticClass: "card_field",
    attrs: {
      "id": "card-name-field-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card_field",
    attrs: {
      "id": "card-number-field-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card_field_50",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "id": "card-expiry-field-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card_field_50",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "id": "card-cvv-field-container"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "id": "card-field-submit-button",
      "type": "button",
      "disabled": _vm.cardSubmitDisabled
    },
    on: {
      "click": function($event) {
        _vm.submitCardPayment()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.cardSubmitDisabled ? 'Processing...' : ("Pay $" + (_vm.formatPrice(_vm.cartTotal)))) + "\n              ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-summary"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('h2', [_vm._v("Order Summary")]), _vm._v(" "), _c('div', {
    staticClass: "summary-items"
  }, _vm._l((_vm.cart), function(item) {
    return _c('div', {
      key: item.variantId,
      staticClass: "summary-item"
    }, [_c('div', {
      staticClass: "summary-item-image"
    }, [(item.image) ? _c('img', {
      attrs: {
        "src": item.image,
        "alt": item.name
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-details"
    }, [_c('div', {
      staticClass: "summary-item-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-variants"
    }, [(item.color) ? _c('span', [_vm._v(_vm._s(item.color))]) : _vm._e(), _vm._v(" "), (item.size) ? _c('span', [_vm._v(_vm._s(item.size))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-qty"
    }, [_vm._v("Qty: " + _vm._s(item.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "summary-item-price"
    }, [_vm._v("\n                  $" + _vm._s(_vm.formatPrice(item.price * item.quantity)) + "\n                ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "summary-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Subtotal")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Shipping")]), _vm._v(" "), _c('span', {
    staticClass: "free-shipping"
  }, [_vm._v("FREE")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-row total"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn-back-to-cart",
    on: {
      "click": function($event) {
        _vm.$router.push('/cart')
      }
    }
  }, [_vm._v("\n            ← Back to Cart\n          ")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    attrs: {
      "id": "content_footer"
    }
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_vm._v("© 2009-" + _vm._s(_vm.year) + " StumptheSpread.com")]), _vm._v(" "), (!_vm.isLogin) ? _c('div', {
    attrs: {
      "id": "back_to_top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollToTop($event)
      }
    }
  }, [_c('div', {
    staticClass: "sprite back_to_top",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "title": "Back to the Top"
    }
  })])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "my-orders-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v("\n        Loading your orders...\n      ")]) : (_vm.error) ? _c('div', {
    staticClass: "error-state"
  }, [_c('div', {
    staticClass: "error-icon"
  }, [_vm._v("⚠️")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))])]) : (_vm.orders.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_vm._v("📦")]), _vm._v(" "), _c('h2', [_vm._v("No orders yet")]), _vm._v(" "), _c('p', [_vm._v("You haven't placed any orders yet. Start shopping!")]), _vm._v(" "), _c('button', {
    staticClass: "btn-shop",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n          Browse Products\n        ")])]) : _c('div', {
    staticClass: "orders-list"
  }, _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order.id,
      staticClass: "order-card",
      on: {
        "click": function($event) {
          _vm.viewOrder(order.id)
        }
      }
    }, [_c('div', {
      staticClass: "order-header"
    }, [_c('div', {
      staticClass: "order-info"
    }, [_c('h3', [_vm._v("Order #" + _vm._s(order.order_number))]), _vm._v(" "), _c('p', {
      staticClass: "order-date"
    }, [_vm._v(_vm._s(_vm.formatDate(order.created_at)))])]), _vm._v(" "), _c('div', {
      staticClass: "order-status"
    }, [_c('span', {
      class: ['status-badge', order.status]
    }, [_vm._v("\n                " + _vm._s(_vm.formatStatus(order.status)) + "\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "order-items-preview"
    }, [_vm._l((order.items.slice(0, 3)), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "item-preview"
      }, [_c('div', {
        staticClass: "item-image-small"
      }, [(item.product && item.product.images && item.product.images.length > 0) ? _c('img', {
        attrs: {
          "src": _vm.getPrimaryImage(item.product).image_url,
          "alt": item.product_name
        }
      }) : _c('div', {
        staticClass: "no-image-small"
      }, [_vm._v("?")])])])
    }), _vm._v(" "), (order.items.length > 3) ? _c('span', {
      staticClass: "more-items"
    }, [_vm._v("\n              +" + _vm._s(order.items.length - 3) + " more\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "order-footer"
    }, [_c('div', {
      staticClass: "order-total"
    }, [_c('span', {
      staticClass: "total-label"
    }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
      staticClass: "total-amount"
    }, [_vm._v("$" + _vm._s(_vm.formatPrice(order.total_cents)))])]), _vm._v(" "), _c('button', {
      staticClass: "btn-view",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.viewOrder(order.id)
        }
      }
    }, [_vm._v("\n              View Details →\n            ")])])])
  }))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("My Orders")]), _vm._v(" "), _c('p', [_vm._v("View and track your order history")])])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Buy Picks")]), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, [((_vm.month === 8) && _vm.nhlFull) ? _c('li', [_c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Featured: NHL Full Season Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n          Full Season of NHL Hockey Picks! Only "), (_vm.mlbFull.current_price !== _vm.mlbFull.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.nhlFull.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.nhlFull.current_price) + ".\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.nhlFull,
      "color": 'gold'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]) : _vm._e(), _vm._v(" "), ((_vm.month === 2 || _vm.month === 3) && _vm.mlbFull) ? _c('li', [_c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("MLB Full Season Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n          Full Season of MLB Baseball Picks! Only "), (_vm.mlbFull.current_price !== _vm.mlbFull.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.mlbFull.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.mlbFull.current_price) + ".\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.mlbFull,
      "color": 'gold'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]) : _vm._e(), _vm._v(" "), (_vm.month === 7 && _vm.nflFull) ? _c('li', [_c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("NFL Full Season Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n      Full Season of NFL Picks! Includes Pre-season and Playoffs. Only "), (_vm.nflFull.current_price !== _vm.nflFull.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.nflFull.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.nflFull.current_price) + ".\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.nflFull,
      "color": 'gold'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]) : _vm._e(), _vm._v(" "), (_vm.month === 7 && _vm.ncaafFull) ? _c('li', [_c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("NCAAF Full Season Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n      Full Season of College Football Picks! Only "), (_vm.ncaafFull.current_price !== _vm.ncaafFull.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.ncaafFull.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.ncaafFull.current_price) + ".\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.ncaafFull,
      "color": 'gold'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]) : _vm._e(), _vm._v(" "), (_vm.month === 9 && _vm.nbaFull) ? _c('li', [_c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Featured: NBA Full Season Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n        Full Season of NBA Picks! Includes Playoffs. Only "), (_vm.nbaFull.current_price !== _vm.nbaFull.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.nbaFull.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.nbaFull.current_price) + ".\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.nbaFull,
      "color": 'gold'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]) : _vm._e(), _vm._v(" "), (_vm.month === 10 && _vm.ncaabFull) ? _c('li', [_c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("NCAAB Full Season Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n      Full Season of NCAAB Picks! Includes Pre-season and Playoffs. Only "), (_vm.ncaabFull.current_price !== _vm.ncaabFull.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.ncaabFull.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.ncaabFull.current_price) + ".\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.ncaabFull,
      "color": 'gold'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "article"
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "id": "sport_dropdown"
    }
  }, [_c('label', {
    attrs: {
      "for": "sport"
    }
  }, [_vm._v("Sport:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSport),
      expression: "selectedSport"
    }],
    attrs: {
      "name": "sport",
      "id": "sports"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSport = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onSportChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "2343a835-82ae-4b4b-bb50-689912b97571"
    }
  }, [_vm._v("ALL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ba74ccae-1bfb-4a56-92d4-402a33d230bf"
    }
  }, [_vm._v("NFL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "a2b8b898-5add-4522-a081-fb1030748310"
    }
  }, [_vm._v("NCAAF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "c8695b24-eab6-4ee6-b8ab-d99418df69d6"
    }
  }, [_vm._v("MLB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fe1cf0cd-2368-41aa-aaed-12645fdc3ef9"
    }
  }, [_vm._v("NBA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "51352c74-5dcc-4a32-b1b9-385c88e2fee6"
    }
  }, [_vm._v("NCAAB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "a93e012c-e29a-49ab-901e-ed5396c87212"
    }
  }, [_vm._v("NHL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "572cd870-23f9-41b5-80b3-11e1dd568ab5"
    }
  }, [_vm._v("UFC")])])])]), _vm._v(" "), _vm._l((_vm.packages), function(package, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "article"
    }, [_c('a', {
      staticClass: "title_article",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(package.name))]), _vm._v(" "), _c('p', {
      staticClass: "text_article"
    }, [_vm._v("\n            " + _vm._s(package.name) + " " + _vm._s(package.description) + " Only "), (package.current_price !== package.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(package.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(package.current_price) + ".\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('purchase-button', {
      attrs: {
        "package": package,
        "color": 'gold'
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "separator"
    })])
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/managerecord'
      }
    }
  }, [_vm._v("Manage Record")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "content_header"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('div', {
    staticClass: "sprite logo",
    staticStyle: {
      "display": "inline-block"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript;"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [(_vm.currentUser) ? _c('div', {
    staticClass: "search sprite Go_Out",
    attrs: {
      "title": "Logout"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.currentUser) ? _c('cart-icon') : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left",
      "width": "100%"
    }
  }, [_vm._v("Purchase Premium Picks")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "width": "100%"
    },
    attrs: {
      "id": "package_information"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "id": "sport_dropdown"
    }
  }, [_c('label', {
    attrs: {
      "for": "sport"
    }
  }, [_vm._v("Sport:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSport),
      expression: "selectedSport"
    }],
    attrs: {
      "name": "sport",
      "id": "sports"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSport = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onSportChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "2343a835-82ae-4b4b-bb50-689912b97571"
    }
  }, [_vm._v("ALL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ba74ccae-1bfb-4a56-92d4-402a33d230bf"
    }
  }, [_vm._v("NFL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "a2b8b898-5add-4522-a081-fb1030748310"
    }
  }, [_vm._v("NCAAF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "c8695b24-eab6-4ee6-b8ab-d99418df69d6"
    }
  }, [_vm._v("MLB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fe1cf0cd-2368-41aa-aaed-12645fdc3ef9"
    }
  }, [_vm._v("NBA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "51352c74-5dcc-4a32-b1b9-385c88e2fee6"
    }
  }, [_vm._v("NCAAB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "a93e012c-e29a-49ab-901e-ed5396c87212"
    }
  }, [_vm._v("NHL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "572cd870-23f9-41b5-80b3-11e1dd568ab5"
    }
  }, [_vm._v("UFC")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "membership_dropdown"
    }
  }, [_c('label', {
    attrs: {
      "for": "membership"
    }
  }, [_vm._v("Membership:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageId),
      expression: "packageId"
    }],
    attrs: {
      "name": "membership",
      "id": "memberships"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.packageId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.emitSelection]
    }
  }, [(_vm.dataPackage.special) ? _c('option', {
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": _vm.dataPackage.id
    }
  }, [_vm._v(_vm._s(_vm.dataPackage.name))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.packages), function(option, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.name))])
  })], 2)])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "red"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('div', {
    staticClass: "paypal-button-container",
    attrs: {
      "id": "paypal-button-container"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card_container",
    attrs: {
      "id": "card-form"
    }
  }, [_c('div', {
    attrs: {
      "id": "card-name-field-container"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-number-field-container"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-expiry-field-container"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card-cvv-field-container"
    }
  }), _vm._v(" "), (_vm.dataPackage) ? _c('button', {
    attrs: {
      "id": "card-field-submit-button",
      "type": "button",
      "disabled": _vm.purchaseDisabled
    },
    on: {
      "click": function($event) {
        _vm.purchase()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.buttonText) + "\n        ")]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Spacer-module_divider__ewqEj"
  }, [_c('span', [_vm._v("OR")])])
}]}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "order-confirmation-page"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n        Loading order details...\n      ")]) : (_vm.error) ? _c('div', {
    staticClass: "error-state"
  }, [_c('div', {
    staticClass: "error-icon"
  }, [_vm._v("⚠️")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "btn-home",
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  }, [_vm._v("\n          Go to Home\n        ")])]) : (_vm.order) ? _c('div', {
    staticClass: "confirmation-content"
  }, [_c('div', {
    staticClass: "success-header"
  }, [_c('div', {
    staticClass: "success-icon"
  }, [_vm._v("✓")]), _vm._v(" "), _c('h1', [_vm._v("Order Confirmed!")]), _vm._v(" "), _c('p', [_vm._v("Thank you for your purchase. Your order has been received and is being processed.")])]), _vm._v(" "), _c('div', {
    staticClass: "order-details-card"
  }, [_c('div', {
    staticClass: "order-header"
  }, [_c('div', {
    staticClass: "order-info"
  }, [_c('h2', [_vm._v("Order #" + _vm._s(_vm.order.order_number))]), _vm._v(" "), _c('p', {
    staticClass: "order-date"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.order.created_at)))])]), _vm._v(" "), _c('div', {
    staticClass: "order-status"
  }, [_c('span', {
    class: ['status-badge', _vm.order.status]
  }, [_vm._v("\n                " + _vm._s(_vm.formatStatus(_vm.order.status)) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-items-section"
  }, [_c('h3', [_vm._v("Order Items")]), _vm._v(" "), _c('div', {
    staticClass: "order-items"
  }, _vm._l((_vm.order.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "order-item"
    }, [_c('div', {
      staticClass: "item-image"
    }, [(item.product && item.product.images && item.product.images.length > 0) ? _c('img', {
      attrs: {
        "src": _vm.getPrimaryImage(item.product).image_url,
        "alt": item.product_name
      }
    }) : _c('div', {
      staticClass: "no-image"
    }, [_vm._v("No Image")])]), _vm._v(" "), _c('div', {
      staticClass: "item-details"
    }, [_c('div', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), _c('div', {
      staticClass: "item-variants"
    }, [(item.color) ? _c('span', [_vm._v(_vm._s(item.color))]) : _vm._e(), _vm._v(" "), (item.size) ? _c('span', [_vm._v(_vm._s(item.size))]) : _vm._e()]), _vm._v(" "), (item.product_variant && item.product_variant.sku) ? _c('div', {
      staticClass: "item-sku"
    }, [_vm._v("\n                    SKU: " + _vm._s(item.product_variant.sku) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-quantity"
    }, [_vm._v("\n                  Qty: " + _vm._s(item.quantity) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "item-price"
    }, [_vm._v("\n                  $" + _vm._s(_vm.formatPrice(item.unit_price_cents)) + "\n                ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "shipping-section"
  }, [_c('h3', [_vm._v("Shipping Address")]), _vm._v(" "), _c('div', {
    staticClass: "shipping-address"
  }, [_c('p', [_vm._v(_vm._s(_vm.order.shipping_first_name) + " " + _vm._s(_vm.order.shipping_last_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.shipping_address_line1))]), _vm._v(" "), (_vm.order.shipping_address_line2) ? _c('p', [_vm._v(_vm._s(_vm.order.shipping_address_line2))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.shipping_city) + ", " + _vm._s(_vm.order.shipping_state) + " " + _vm._s(_vm.order.shipping_postal_code))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.order.shipping_country))]), _vm._v(" "), _c('p', {
    staticClass: "shipping-email"
  }, [_vm._v(_vm._s(_vm.order.shipping_email))])])]), _vm._v(" "), _c('div', {
    staticClass: "section-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "order-summary"
  }, [_c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Subtotal")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.order.subtotal_cents)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Shipping")]), _vm._v(" "), _c('span', {
    staticClass: "free-shipping"
  }, [_vm._v("FREE")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row total"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.order.total_cents)))])])]), _vm._v(" "), _c('div', {
    staticClass: "email-notice"
  }, [_c('p', [_vm._v("📧 A confirmation email has been sent to "), _c('strong', [_vm._v(_vm._s(_vm.order.shipping_email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [(_vm.isAuthenticated) ? _c('button', {
    staticClass: "btn-orders",
    on: {
      "click": function($event) {
        _vm.$router.push('/orders')
      }
    }
  }, [_vm._v("\n            View My Orders\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-shop",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n            Continue Shopping\n          ")])])]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow"
  }, [_vm._v("Forgot Password")]), _vm._v(" "), (_vm.errors.any() || _vm.error) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter a valid email")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [(!_vm.sent) ? _c('form', {
    attrs: {
      "name": "formregister"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendForgot($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "email",
      "maxlength": "100",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Reset Password",
      "name": "submitButton"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.sent) ? _c('div', [_c('p', [_vm._v("Password reset successfully. ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text_form"
  }, [_vm._v("\n        Enter Email: "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Please check your email for your new password. The password can be changed in the my account section after logging in with your new password. "), _c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Log in.")])])
}]}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow"
  }, [_vm._v(_vm._s(_vm.registered ? 'Success!' : 'Register'))]), _vm._v(" "), (_vm.errors.any() || _vm.error) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('fname')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Please enter your first name")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('lname')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Please enter your last name")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter a valid email")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e(), _vm._v(" "), (_vm.errors.has('repeatpassword')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("Please repeat password")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [(!_vm.registered) ? _c('form', {
    attrs: {
      "name": "formregister"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.fname),
      expression: "user.fname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "fname",
      "maxlength": "25",
      "data-vv-delay": "2000",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.user.fname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.fname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lname),
      expression: "user.lname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "lname",
      "maxlength": "50",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.user.lname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.lname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "email",
      "maxlength": "100",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:8|required|confirmed:repeatpassword'),
      expression: "'min:8|required|confirmed:repeatpassword'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "name": "password",
      "maxlength": "30",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirmPassword),
      expression: "user.confirmPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "id": "label_name",
      "name": "repeatpassword",
      "maxlength": "30",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.user.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Register",
      "name": "submitButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signup($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.registered) ? _c('div', [_vm._v("\n      You have successfully registered. "), _c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Please log in.")])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Already a member? "), _c('router-link', {
    attrs: {
      "to": {
        path: '/login'
      }
    }
  }, [_vm._v("Login in.")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text_form"
  }, [_vm._v("\n        First Name: "), _c('br'), _vm._v("\n        Last Name: "), _c('br'), _vm._v("\n        Email: "), _c('br'), _vm._v("\n        Password: "), _c('br'), _vm._v("\n        Repeat PW:\n      ")])
}]}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-icon",
    on: {
      "click": _vm.goToCart
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "9",
      "cy": "21",
      "r": "1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "20",
      "cy": "21",
      "r": "1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
    }
  })]), _vm._v(" "), (_vm.cartItemCount > 0) ? _c('span', {
    staticClass: "cart-badge"
  }, [_vm._v(_vm._s(_vm.cartItemCount))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Help")]), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite dollar_currency_sign",
    attrs: {
      "title": "Buy Picks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_vm._v("Buy Picks")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("The dollar sign takes you to the buy picks screen.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite user",
    attrs: {
      "title": "Testimonials"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_vm._v("Testimonials")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("The user takes you to the testimonials screen.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/picks'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite lock",
    attrs: {
      "title": "View Picks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/picks'
      }
    }
  }, [_vm._v("View Picks")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("The lock takes you to the testimonials screen.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite email",
    attrs: {
      "title": "Blog"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_vm._v("Blog")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("The @ sign takes you to the blog.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tools/size'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite chart_up",
    attrs: {
      "title": "Bet Calculator"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/tools/size'
      }
    }
  }, [_vm._v("Bet Calculator")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("This icon takes you to the bet calculator.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite mail",
    attrs: {
      "title": "Contact Us"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("The mail icon takes you to the contact page")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', [_c('img', {
    attrs: {
      "src": "/static/images/Go_Out.png",
      "width": "38px",
      "height": "38px",
      "alt": "Logout"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "title_article"
  }, [_vm._v("Logout")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("This icon will log you out of the website.")])]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })])
}]}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Picks")]), _vm._v(" "), (_vm.sportOptions.length > 2) ? _c('div', {
    staticClass: "sport-filter"
  }, _vm._l((_vm.sportOptions), function(opt) {
    return _c('button', {
      key: opt,
      staticClass: "sport-pill",
      class: {
        active: _vm.selectedSport === opt
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectSport(opt)
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.sportLabel(opt)) + "\n      ")])
  })) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, [_c('li', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [(!_vm.user || !_vm.user.premium) ? _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7783278999",
      "ad-layout-key": "-8i+1w-dq+e9+ft",
      "ad-format": "fluid"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredPicks), function(pick) {
    return _c('div', {
      staticClass: "article"
    }, [_c('a', {
      staticClass: "title_article",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(pick.title))]), _vm._v(" "), _c('p', {
      staticClass: "text_article",
      domProps: {
        "innerHTML": _vm._s(pick.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text_article_pick"
    }, [_c('b', {
      staticClass: "article_pick"
    }, [_vm._v(_vm._s(pick.pick))]), _vm._v("\n             \n          "), _c('b', {
      staticClass: "article_pick"
    }, [_vm._v(_vm._s(pick.side))]), _vm._v("\n             \n          "), _c('b', {
      staticClass: "article_pick"
    }, [_vm._v(_vm._s(pick.price))]), _vm._v("\n             \n          "), _c('b', {
      staticClass: "article_pick"
    }, [_vm._v(_vm._s(pick.units))]), _vm._v("\n           \n           "), _c('b', {
      staticClass: "article_pick"
    }, [_vm._v(_vm._s(pick.units == 1 ? 'unit' : 'units'))])])])
  }), _vm._v(" "), (_vm.picks && _vm.picks.length === 0) ? _c('p', [_vm._v("There are no picks currently posted. To receive picks immediately when they are posted, please set up pick notifications in the "), _c('router-link', {
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_vm._v("my account section (premium members only).")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 2)]), _vm._v(" "), (_vm.user && !_vm.user.premium) ? _c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "height": "20px"
    }
  }, [_vm._v("Buy Premium Picks")]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.user.premium) ? _c('ul', {
    staticClass: "articles"
  }, [_c('li', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [(_vm.allYear) ? _c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("1 Year All Sports Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n            Every single expert pick for 365 days! Only "), (_vm.allYear.current_price !== _vm.allYear.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.allYear.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.allYear.current_price) + ". Best Value!\n            "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allYear,
      "color": 'gold'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]), _vm._v(" "), _c('li', [(_vm.allMonth) ? _c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("1 Month All Sports Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n        Get our top rated plays. Every single expert pick for one month. Only "), (_vm.allMonth.current_price !== _vm.allMonth.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.allMonth.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.allMonth.current_price) + ".\n        "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allMonth,
      "color": 'gold'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]), _vm._v(" "), _c('li', [(_vm.allTwo) ? _c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("2 Weeks All Sports Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n      2 Weeks All Sports Package. Every single expert pick for 2 weeks. Only "), (_vm.allTwo.current_price !== _vm.allTwo.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.allTwo.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.allTwo.current_price) + ".\n      "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allTwo,
      "color": 'gold'
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })]), _vm._v(" "), _c('li', [(_vm.allWeek) ? _c('div', {
    staticClass: "article"
  }, [_c('a', {
    staticClass: "title_article",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("1 Week All Sports Package")]), _vm._v(" "), _c('p', {
    staticClass: "text_article"
  }, [_vm._v("\n      1 Week All Sports Package. Every single expert pick for one week. Only "), (_vm.allWeek.current_price !== _vm.allWeek.previous_price) ? _c('strike', [_vm._v("$" + _vm._s(_vm.allWeek.previous_price))]) : _vm._e(), _vm._v(" $" + _vm._s(_vm.allWeek.current_price) + ".\n      "), _c('br'), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allWeek,
      "color": 'gold'
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7783278999",
      "ad-layout-key": "-8i+1w-dq+e9+ft",
      "ad-format": "fluid"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Blog")]), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7783278999",
      "ad-layout-key": "-8i+1w-dq+e9+ft",
      "ad-format": "fluid"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', [_c('div', {
      staticClass: "article"
    }, [_c('a', {
      staticClass: "title_article",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(post.title))]), _vm._v(" "), _c('p', {
      staticClass: "text_article",
      domProps: {
        "innerHTML": _vm._s(post.content)
      }
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(post.date))])]), _vm._v(" "), _c('div', {
      staticClass: "separator"
    })])
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow"
  }, [_vm._v("Change Password")]), _vm._v(" "), (_vm.errors.any() || _vm.error) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('oldPassword')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Please enter your current password")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('newPassword')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter your new password")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('confirmPassword')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("Please repeat password")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('form', {
    attrs: {
      "name": "change"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:8|required'),
      expression: "'min:8|required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "name": "oldPassword",
      "maxlength": "30",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:8|required|confirmed:confirmPassword'),
      expression: "'min:8|required|confirmed:confirmPassword'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "name": "newPassword",
      "maxlength": "30",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "id": "label_name",
      "name": "confirmPassword",
      "maxlength": "30",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Submit",
      "name": "submitButton",
      "title": "Submit"
    }
  })])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text_form"
  }, [_vm._v("\n          Current: "), _c('br'), _vm._v("\n          New: "), _c('br'), _vm._v("\n          Confirm:\n        ")])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "menu_index"
    }
  }, [_c('ul', {
    staticClass: "articles"
  }, [(_vm.user && _vm.user.admin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/admin'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite process"
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/admin'
      }
    }
  }, [_vm._v("Admin")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.user || !_vm.user.admin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite dollar_currency_sign",
    attrs: {
      "title": "Buy Picks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_vm._v("Buy Picks")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite user"
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_vm._v("Testimonials")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/picks'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite lock",
    attrs: {
      "title": "View Picks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/picks'
      }
    }
  }, [_vm._v("View Picks")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tools/size'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite chart_up",
    attrs: {
      "title": "tools"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/tools/size'
      }
    }
  }, [_vm._v("Bet Calculator")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite process",
    attrs: {
      "title": "My Account"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_vm._v("My Account")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite email",
    attrs: {
      "title": "Blog"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_vm._v("Blog")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite mail",
    attrs: {
      "title": "Contact Us"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/help'
      }
    }
  }, [_c('div', {
    staticClass: "img_left sprite comment",
    attrs: {
      "title": "Need Help?"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/help'
      }
    }
  }, [_vm._v("Help?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/shop'
      }
    }
  }, [_c('div', {
    staticClass: "img_left shop-icon",
    attrs: {
      "title": "Shop"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article"
  }, [_c('router-link', {
    staticClass: "title_article",
    attrs: {
      "to": {
        path: '/shop'
      }
    }
  }, [_vm._v("Shop")])], 1), _vm._v(" "), _c('div', {
    staticClass: "separator"
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "shop-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("StumpTheSpread Shop")]), _vm._v(" "), _c('div', {
    staticClass: "picks-notice"
  }, [_c('p', [_vm._v("Looking to purchase picks? "), _c('router-link', {
    attrs: {
      "to": "/buy"
    }
  }, [_vm._v("Click here to Buy Premium Picks!")])], 1)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n        Loading products...\n      ")]) : (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : (_vm.products.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('p', [_vm._v("No products available at the moment.")])]) : _c('div', {
    staticClass: "product-grid"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "product-card",
      on: {
        "click": function($event) {
          _vm.viewProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "product-image"
    }, [(product.is_on_sale) ? _c('div', {
      staticClass: "sale-badge"
    }, [_vm._v("SALE")]) : _vm._e(), _vm._v(" "), (_vm.primaryImage(product)) ? _c('img', {
      attrs: {
        "src": _vm.primaryImage(product).image_url,
        "alt": product.name
      }
    }) : _c('div', {
      staticClass: "no-image"
    }, [_vm._v("No Image")])]), _vm._v(" "), _c('div', {
      staticClass: "product-info"
    }, [_c('h3', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('p', {
      staticClass: "product-description"
    }, [_vm._v(_vm._s(_vm.truncateDescription(product.description)))]), _vm._v(" "), _c('div', {
      staticClass: "product-footer"
    }, [_c('div', {
      staticClass: "price-container"
    }, [(product.is_on_sale) ? _c('span', {
      staticClass: "product-price-regular"
    }, [_vm._v("\n                  $" + _vm._s(_vm.formatPrice(product.base_price_cents)) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "product-price",
      class: {
        'product-price-sale': product.is_on_sale
      }
    }, [_vm._v("\n                  $" + _vm._s(_vm.formatPrice(product.is_on_sale ? product.sale_price_cents : product.base_price_cents)) + "\n                ")]), _vm._v(" "), (product.is_on_sale && product.discount_percentage) ? _c('span', {
      staticClass: "discount-badge"
    }, [_vm._v("\n                  -" + _vm._s(product.discount_percentage) + "%\n                ")]) : _vm._e()]), _vm._v(" "), _c('button', {
      staticClass: "btn-view"
    }, [_vm._v("View Details")])])])])
  }))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "product-detail-page"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n        Loading product...\n      ")]) : (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : (_vm.product) ? _c('div', {
    staticClass: "product-detail"
  }, [_c('div', {
    staticClass: "product-images"
  }, [_c('div', {
    staticClass: "main-image"
  }, [(_vm.selectedImage) ? _c('img', {
    attrs: {
      "src": _vm.selectedImage.image_url,
      "alt": _vm.product.name
    }
  }) : _c('div', {
    staticClass: "no-image"
  }, [_vm._v("No Image")])]), _vm._v(" "), (_vm.product.images && _vm.product.images.length > 1) ? _c('div', {
    staticClass: "image-thumbnails"
  }, _vm._l((_vm.product.images), function(image) {
    return _c('div', {
      key: image.id,
      staticClass: "thumbnail",
      class: {
        active: _vm.selectedImage && _vm.selectedImage.id === image.id
      },
      on: {
        "click": function($event) {
          _vm.selectedImage = image
        }
      }
    }, [_c('img', {
      attrs: {
        "src": image.image_url,
        "alt": _vm.product.name
      }
    })])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-info-section"
  }, [_c('h1', {
    staticClass: "product-title"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-price-section"
  }, [(_vm.product.is_on_sale) ? _c('div', {
    staticClass: "sale-badge-large"
  }, [_vm._v("\n              SALE - SAVE " + _vm._s(_vm.product.discount_percentage) + "%\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "price-display"
  }, [(_vm.product.is_on_sale) ? _c('span', {
    staticClass: "price-regular"
  }, [_vm._v("\n                $" + _vm._s(_vm.formatPrice(_vm.regularPrice)) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "price-current",
    class: {
      'price-sale': _vm.product.is_on_sale
    }
  }, [_vm._v("\n                $" + _vm._s(_vm.formatPrice(_vm.currentPrice)) + "\n              ")])]), _vm._v(" "), (_vm.product.is_on_sale) ? _c('div', {
    staticClass: "sale-message"
  }, [_vm._v("\n              🎉 Limited time offer! Save $" + _vm._s(_vm.formatPrice(_vm.regularPrice - _vm.currentPrice)) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.product.description))])]), _vm._v(" "), (_vm.product.variants && _vm.product.variants.length > 0) ? _c('div', {
    staticClass: "variant-selection"
  }, [(_vm.availableColors.length > 0) ? _c('div', {
    staticClass: "variant-group"
  }, [_c('label', [_vm._v("Color:")]), _vm._v(" "), _c('div', {
    staticClass: "variant-options"
  }, _vm._l((_vm.availableColors), function(color) {
    return _c('button', {
      key: color,
      staticClass: "variant-btn",
      class: {
        active: _vm.selectedColor === color
      },
      on: {
        "click": function($event) {
          _vm.selectedColor = color
        }
      }
    }, [_vm._v("\n                  " + _vm._s(color) + "\n                ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.availableSizes.length > 0) ? _c('div', {
    staticClass: "variant-group"
  }, [_c('label', [_vm._v("Size:")]), _vm._v(" "), _c('div', {
    staticClass: "variant-options"
  }, _vm._l((_vm.availableSizes), function(size) {
    return _c('button', {
      key: size,
      staticClass: "variant-btn",
      class: {
        active: _vm.selectedSize === size
      },
      on: {
        "click": function($event) {
          _vm.selectedSize = size
        }
      }
    }, [_vm._v("\n                  " + _vm._s(size) + "\n                ")])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "quantity-section"
  }, [_c('label', [_vm._v("Quantity:")]), _vm._v(" "), _c('div', {
    staticClass: "quantity-control"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.quantity <= 1
    },
    on: {
      "click": _vm.decrementQuantity
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.quantity),
      expression: "quantity",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantity = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.incrementQuantity
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [_c('button', {
    staticClass: "btn-add-to-cart",
    attrs: {
      "disabled": !_vm.selectedVariant || !_vm.isAuthenticated
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isAuthenticated ? 'Add to Cart' : 'Login to Purchase') + "\n            ")]), _vm._v(" "), (_vm.cartItemCount > 0) ? _c('button', {
    staticClass: "btn-checkout",
    on: {
      "click": function($event) {
        _vm.$router.push('/checkout')
      }
    }
  }, [_vm._v("\n              Go to Checkout\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n              Back to Shop\n            ")])]), _vm._v(" "), (!_vm.isAuthenticated) ? _c('div', {
    staticClass: "auth-notice"
  }, [_vm._v("\n            Please "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("login")]), _vm._v(" to add items to your cart.\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.addedToCart) ? _c('div', {
    staticClass: "success-message"
  }, [_vm._v("\n            Added to cart! "), _c('router-link', {
    attrs: {
      "to": "/cart"
    }
  }, [_vm._v("View Cart")])], 1) : _vm._e()])]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Testimonials")]), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, _vm._l((_vm.testimonials), function(test) {
    return _c('li', [_c('div', {
      staticClass: "article"
    }, [_c('p', {
      staticClass: "text_article"
    }, [_vm._v(_vm._s(test.content))]), _vm._v(" "), _c('cite', [_vm._v(_vm._s(test.author) + ",  "), _c('b', [_vm._v(_vm._s(test.type))])])]), _vm._v(" "), _c('div', {
      staticClass: "separator"
    })])
  })), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7783278999",
      "ad-layout-key": "-8i+1w-dq+e9+ft",
      "ad-format": "fluid"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [(_vm.errors.any() || _vm.error) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('username')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Please enter your email")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter a password")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('form', {
    attrs: {
      "name": "login"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "username",
      "data-vv-delay": "2000",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "name": "password",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Login",
      "name": "submitButton",
      "title": "Login"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Not a member? "), _c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("Click here to register for free.")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        path: '/forgotpassword'
      }
    }
  }, [_vm._v(" Forgot Password?")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text_form"
  }, [_vm._v("\n        Email: "), _c('br'), _vm._v("\n        Password:\n      ")])
}]}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "cart-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Shopping Cart")]), _vm._v(" "), (_vm.cart.length === 0) ? _c('div', {
    staticClass: "empty-cart"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_vm._v("🛒")]), _vm._v(" "), _c('h2', [_vm._v("Your cart is empty")]), _vm._v(" "), _c('p', [_vm._v("Add some items from our shop to get started!")]), _vm._v(" "), _c('button', {
    staticClass: "btn-continue-shopping",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n          Continue Shopping\n        ")])]) : _c('div', {
    staticClass: "cart-content"
  }, [_c('div', {
    staticClass: "cart-items"
  }, _vm._l((_vm.cart), function(item) {
    return _c('div', {
      key: item.variantId,
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "item-image"
    }, [(item.image) ? _c('img', {
      attrs: {
        "src": item.image,
        "alt": item.name
      }
    }) : _c('div', {
      staticClass: "no-image"
    }, [_vm._v("No Image")])]), _vm._v(" "), _c('div', {
      staticClass: "item-details"
    }, [_c('h3', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "item-variants"
    }, [(item.color) ? _c('span', {
      staticClass: "variant-badge"
    }, [_vm._v(_vm._s(item.color))]) : _vm._e(), _vm._v(" "), (item.size) ? _c('span', {
      staticClass: "variant-badge"
    }, [_vm._v(_vm._s(item.size))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-price"
    }, [(item.isOnSale) ? _c('span', {
      staticClass: "sale-indicator"
    }, [_vm._v("SALE")]) : _vm._e(), _vm._v("\n                $" + _vm._s(_vm.formatPrice(item.price)) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "item-actions"
    }, [_c('div', {
      staticClass: "quantity-control"
    }, [_c('button', {
      attrs: {
        "disabled": item.quantity <= 1
      },
      on: {
        "click": function($event) {
          _vm.decrementQuantity(item)
        }
      }
    }, [_vm._v("\n                  -\n                ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.quantity),
        expression: "item.quantity",
        modifiers: {
          "number": true
        }
      }],
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": (item.quantity)
      },
      on: {
        "change": function($event) {
          _vm.updateQuantity(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          item.quantity = _vm._n($event.target.value)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.incrementQuantity(item)
        }
      }
    }, [_vm._v("+")])]), _vm._v(" "), _c('div', {
      staticClass: "item-total"
    }, [_vm._v("\n                $" + _vm._s(_vm.formatPrice(item.price * item.quantity)) + "\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn-remove",
      attrs: {
        "title": "Remove item"
      },
      on: {
        "click": function($event) {
          _vm.removeItem(item)
        }
      }
    }, [_vm._v("\n                ×\n              ")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "cart-summary"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('h2', [_vm._v("Order Summary")]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Subtotal (" + _vm._s(_vm.cartItemCount) + " items)")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Shipping")]), _vm._v(" "), _c('span', {
    staticClass: "free-shipping"
  }, [_vm._v("FREE")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-row total"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.cartTotal)))])]), _vm._v(" "), (_vm.isAuthenticated) ? _c('button', {
    staticClass: "btn-checkout",
    on: {
      "click": function($event) {
        _vm.$router.push('/checkout')
      }
    }
  }, [_vm._v("\n              Proceed to Checkout\n            ")]) : _c('button', {
    staticClass: "btn-login",
    on: {
      "click": function($event) {
        _vm.$router.push('/login')
      }
    }
  }, [_vm._v("\n              Login to Checkout\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-continue-shopping",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n              Continue Shopping\n            ")]), _vm._v(" "), (!_vm.isAuthenticated) ? _c('div', {
    staticClass: "auth-notice"
  }, [_vm._v("\n              Please "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("login")]), _vm._v(" to complete your purchase.\n            ")], 1) : _vm._e()])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "ios-modal"
  }, [_c('h3', [_vm._v("Install StumptheSpread")]), _vm._v(" "), _c('p', {
    staticClass: "ios-subtitle"
  }, [_vm._v("Push notifications require the app to be installed on your home screen.")]), _vm._v(" "), _c('div', {
    staticClass: "ios-steps"
  }, [_c('div', {
    staticClass: "ios-step"
  }, [_c('div', {
    staticClass: "ios-step-number"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "ios-step-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ios-share-icon"
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "#e94560",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "16 6 12 2 8 6"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "2",
      "x2": "12",
      "y2": "15"
    }
  })])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('button', {
    staticClass: "ios-dismiss",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Got it")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Tap the "), _c('strong', [_vm._v("Share")]), _vm._v(" button in Safari")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-step"
  }, [_c('div', {
    staticClass: "ios-step-number"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "ios-step-content"
  }, [_c('p', [_vm._v("Scroll down and tap "), _c('strong', [_vm._v("\"Add to Home Screen\"")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-step"
  }, [_c('div', {
    staticClass: "ios-step-number"
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "ios-step-content"
  }, [_c('p', [_vm._v("Tap "), _c('strong', [_vm._v("\"Add\"")]), _vm._v(" in the top right")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-step"
  }, [_c('div', {
    staticClass: "ios-step-number"
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "ios-step-content"
  }, [_c('p', [_vm._v("Open "), _c('strong', [_vm._v("StumptheSpread")]), _vm._v(" from your home screen")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-step"
  }, [_c('div', {
    staticClass: "ios-step-number"
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "ios-step-content"
  }, [_c('p', [_vm._v("Come back here to "), _c('strong', [_vm._v("enable notifications")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ios-arrow-container"
  }, [_c('div', {
    staticClass: "ios-arrow"
  }, [_vm._v("↓")])])
}]}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-button-container"
  }, [_c('a', {
    class: ['button', 'zoid', _vm.mutableColor],
    style: (_vm.computedStyle),
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n  Purchase $" + _vm._s(_vm.package.current_price) + "\n")])])
},staticRenderFns: []}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow"
  }, [_vm._v("My Account")]), _vm._v(" "), _c('h4', [_vm._v("Status: "), _c('span', [_vm._v(_vm._s(_vm.user && _vm.user.premium ? 'Premium' : 'Free'))])]), _vm._v(" "), (!_vm.user || !_vm.user.premium) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_vm._v("Buy Picks!")]) : _vm._e(), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        path: '/changepassword'
      }
    }
  }, [_vm._v("Change Password")])], 1), _vm._v(" "), _c('div', {
    staticClass: "email-field"
  }, [_c('label', {
    staticClass: "email-label"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "email-input",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "notifications-section"
  }, [_c('h4', {
    staticClass: "section-label"
  }, [_vm._v("Pick Notifications")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "form1"
    }
  }, [_c('div', {
    staticClass: "notify-option"
  }, [_c('label', {
    staticClass: "notify-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyEmail),
      expression: "notifyEmail"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyEmail) ? _vm._i(_vm.notifyEmail, null) > -1 : (_vm.notifyEmail)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifyEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyEmail = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyEmail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyEmail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox-label"
  }, [_vm._v("Email")])]), _vm._v(" "), (_vm.notifyEmail) ? _c('div', {
    staticClass: "notify-config"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactEmail),
      expression: "contactEmail"
    }],
    staticClass: "notify-input",
    attrs: {
      "type": "text",
      "name": "contact_email_addr",
      "placeholder": "Enter Contact Email"
    },
    domProps: {
      "value": (_vm.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactEmail = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "notify-option"
  }, [_c('label', {
    staticClass: "notify-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifyPush),
      expression: "notifyPush"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifyPush) ? _vm._i(_vm.notifyPush, null) > -1 : (_vm.notifyPush)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifyPush,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifyPush = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifyPush = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifyPush = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox-label"
  }, [_vm._v("Push Notification")])]), _vm._v(" "), (_vm.notifyPush) ? _c('div', {
    staticClass: "notify-config"
  }, [_c('push-setup', {
    on: {
      "subscribed": _vm.onDeviceSubscribed
    }
  }), _vm._v(" "), (_vm.pushSaveError) ? _c('p', {
    staticClass: "push-save-error"
  }, [_vm._v(_vm._s(_vm.pushSaveError))]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.user.notify_sms || _vm.user.contact_method === 2) ? _c('div', {
    staticClass: "notify-option notify-option-legacy"
  }, [_c('label', {
    staticClass: "notify-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notifySms),
      expression: "notifySms"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.notifySms) ? _vm._i(_vm.notifySms, null) > -1 : (_vm.notifySms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.notifySms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.notifySms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.notifySms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notifySms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox-label"
  }, [_vm._v("Text Message")]), _vm._v(" "), _c('span', {
    staticClass: "legacy-badge"
  }, [_vm._v("Legacy")])]), _vm._v(" "), _c('p', {
    staticClass: "legacy-notice"
  }, [_vm._v("Text messages are no longer available for new sign-ups. Please use Push Notifications instead.")]), _vm._v(" "), (_vm.notifySms) ? _c('div', {
    staticClass: "notify-config"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "carrier-select",
    attrs: {
      "name": "phones",
      "id": "phoneList"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.phone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.phoneOpts), function(p) {
    return _c('option', {
      domProps: {
        "value": p
      }
    }, [_vm._v(_vm._s(p.key))])
  })), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactPhone),
      expression: "contactPhone"
    }],
    staticClass: "notify-input",
    attrs: {
      "type": "text",
      "name": "contact_phone",
      "placeholder": "Enter Contact Phone"
    },
    domProps: {
      "value": (_vm.contactPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactPhone = $event.target.value
      }
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button",
    staticStyle: {
      "width": "100%",
      "margin-top": "16px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_vm._v("Save")])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left",
      "width": "100%"
    }
  }, [_vm._v("Bet Sizing Calculator")]), _vm._v(" "), (_vm.errors.any() || _vm.error) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "12px"
    }
  }, [(_vm.errors.has('bankroll')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Bankroll is required")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('odds')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Enter Odds in American Format")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('edge')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter a valid Edge number")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "float": "left",
      "width": "100%"
    }
  }, [_c('form', [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "bankroll"
    }
  }, [_vm._v("Bankroll:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankroll),
      expression: "bankroll"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "bankroll",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "type": "number",
      "name": "bankroll",
      "maxlength": "10",
      "data-vv-delay": "2000",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.bankroll)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankroll = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "odds"
    }
  }, [_vm._v("American Odds:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odds),
      expression: "odds"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|american_odds'),
      expression: "'required|american_odds'"
    }],
    attrs: {
      "type": "text",
      "name": "odds",
      "maxlength": "10",
      "data-vv-delay": "4000",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.odds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.odds = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "edge"
    }
  }, [_vm._v("Edge:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edge),
      expression: "edge"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    attrs: {
      "type": "text",
      "name": "edge",
      "maxlength": "5",
      "data-vv-delay": "4000",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.edge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "block"
    }
  }, [_c('label', {
    attrs: {
      "for": "risk"
    }
  }, [_vm._v("Risk Tolerance:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMultiplier),
      expression: "selectedMultiplier"
    }],
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "name": "risk"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMultiplier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.multiplierChange]
    }
  }, _vm._l((_vm.multipliers), function(option, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "size-results"
  }, [(_vm.showOptimalBetSize) ? _c('p', {
    staticStyle: {
      "padding-bottom": "6px"
    }
  }, [_vm._v("Optimal Bet Size: $" + _vm._s(_vm.optimal.betSize))]) : _vm._e(), _vm._v(" "), (_vm.showOptimalBetSize) ? _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.optimal.percentage) + " of Bankroll")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Calculate",
      "name": "submitButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.calculate($event)
      }
    }
  })])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sts-header'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('sts-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "push-setup"
  }, [(!_vm.isSupported) ? _c('div', {
    staticClass: "push-message"
  }, [_c('p', [_vm._v("Push notifications are not supported in this browser.")])]) : (!_vm.isConfigured) ? _c('div', {
    staticClass: "push-message"
  }, [_c('p', [_vm._v("Push notifications are not available right now. Please check back later.")])]) : (_vm.needsIOSInstall) ? _c('div', [_c('p', {
    staticClass: "push-message"
  }, [_vm._v("To receive push notifications on iOS, you need to install this app to your home screen first.")]), _vm._v(" "), _c('button', {
    staticClass: "button-push",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showIOSGuide = true
      }
    }
  }, [_vm._v("How to Install")]), _vm._v(" "), (_vm.showIOSGuide) ? _c('ios-install-guide', {
    on: {
      "close": function($event) {
        _vm.showIOSGuide = false
      }
    }
  }) : _vm._e()], 1) : (_vm.permissionState === 'denied') ? _c('div', {
    staticClass: "push-message"
  }, [_c('p', [_vm._v("Push notifications are blocked. To enable them, open your browser settings and allow notifications for this site.")])]) : _c('div', [(_vm.canInstallAndroid) ? _c('div', {
    staticClass: "install-section"
  }, [_c('button', {
    staticClass: "button-push",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.installAndroid()
      }
    }
  }, [_vm._v("Install App")]), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("For the best experience")])]) : _vm._e(), _vm._v(" "), (_vm.justBecameStandalone && !_vm.isSubscribed) ? _c('div', {
    staticClass: "success-message"
  }, [_vm._v("\n      App installed successfully! Now enable push notifications below.\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isSubscribed) ? _c('div', [_c('button', {
    staticClass: "button-push",
    attrs: {
      "type": "button",
      "disabled": _vm.subscribing
    },
    on: {
      "click": function($event) {
        _vm.subscribe()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.subscribing ? 'Enabling...' : 'Enable Push Notifications') + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.isSubscribed) ? _c('div', {
    staticClass: "success-message"
  }, [_vm._v("\n      Push notifications enabled on this device.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.devices.length > 0) ? _c('div', {
    staticClass: "device-section"
  }, [_c('p', {
    staticClass: "device-header"
  }, [_vm._v("Registered devices (" + _vm._s(_vm.devices.length) + "):")]), _vm._v(" "), _c('ul', {
    staticClass: "device-list"
  }, _vm._l((_vm.devices), function(device, index) {
    return _c('li', {
      key: device.id
    }, [_c('span', {
      staticClass: "device-name"
    }, [_vm._v(_vm._s(_vm.deviceLabel(device)))]), _vm._v(" "), _c('button', {
      staticClass: "button-remove",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeDevice(device)
        }
      }
    }, [_vm._v("Remove")])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ins', {
    staticClass: "adsbygoogle",
    style: (_vm.adStyle),
    attrs: {
      "data-ad-client": _vm.adClient,
      "data-ad-slot": _vm.adSlot,
      "data-ad-format": _vm.adFormat,
      "data-ad-layout-key": _vm.adLayoutKey
    }
  })
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigation"
    }
  }, [_c('div', {
    attrs: {
      "id": "content_navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "id": "categories-button"
    },
    on: {
      "click": _vm.openMenu
    }
  }, [_c('div', {
    staticClass: "sprite navigation butt_black right",
    attrs: {
      "title": "Open Menu"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "categories-dropdown"
    }
  }, [_c('div', {
    staticClass: "categories-inside"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_vm._v("Buy Picks")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_vm._v("Testimonials")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/picks'
      }
    }
  }, [_vm._v("View Picks")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_vm._v("Blog")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/results'
      }
    }
  }, [_vm._v("Results")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_vm._v("Contact")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:history.back()"
    }
  }, [_c('div', {
    staticClass: "sprite back butt_black left",
    attrs: {
      "title": "Go Back"
    }
  })])
}]}

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[116]);


// WEBPACK FOOTER //
// static/js/app.0051b613a0df0f1daaec.js